/**
 * ProductDetailPresenter
 * --
 */
import React, { useState } from 'react';

import {
  Content,
  Row,
  Col,
  Title,
  Button,
  ProductItem,
  Slider,
  HtmlContent,
  Tabs,
  Thumbnail,
  Pagination,
  Text,
  Modifier,
  Image,
  ModalLayout,
  KakaoMap,
} from 'components';
import {
  Empty,
  Select,
  Modal,
  Input,
  // Checkbox,
  Spin,
  Button as Btn,
  Tooltip,
  Flex,
} from 'antd';
import {
  DownOutlined,
  HeartFilled,
  HeartOutlined,
  QuestionCircleOutlined,
  // LeftOutlined,
  // RightOutlined,
  ShareAltOutlined,
} from '@ant-design/icons';
import {
  CollapseItem,
  RadioGroup,
  ReviewItem,
  ReviewItemDetail,
} from './components';
import MessageAlert, {
  calculateDiscount,
  calculateRentalMonthlyPayment,
  stringToMoneyFormat,
} from 'utils';
import CONSTANTS from 'constants';
import Formatter from 'utils/Formatter';

import radio_unchecked from 'assets/radio_unchecked.svg';
import radio_checked from 'assets/radio_checked.svg';

// import GroupProduct from 'assets/group_product.png';
import Gift from 'assets/icon/gift_icon.png';

import Kakao from 'assets/svg/kakao.svg';
import Naver from 'assets/svg/naver.svg';
import IconX from 'assets/svg/x_icon.svg';
import more from 'assets/more.svg';
import more_666 from 'assets/more_666.svg';
import Download from 'assets/svg/download.svg';
// import more_999 from 'assets/more_999.svg';
// import arrow_left_999 from 'assets/arrow_left_999.svg';
import plus_w from 'assets/plus_w.svg';
import { encrypt } from 'utils/Crypto';
import calculateApplyPolicy from 'utils/productPolicyUtils';
// 정기배송 주기
// 주기-주기타입-미루기횟수
const REGULAR_OPTION = [
  {
    label: '1주',
    value: '1-W-0',
  },
  {
    label: '2주',
    value: '2-W-0',
  },
  {
    label: '3주',
    value: '3-W-0',
  },
  {
    label: '4주',
    value: '4-W-0',
  },
  {
    label: '1개월',
    value: '1-M-0',
  },
  {
    label: '2개월',
    value: '2-M-0',
  },
  {
    label: '3개월',
    value: '3-M-0',
  },
];

const DELIVERY_METHOD = {
  PARCEL: '택배',
  REGISTERED: '등기',
  PACKAGE: '소포',
};

const PACKAGE_METHOD = {
  GENERAL: '일반',
  REFRIGERATION: '냉장',
  FREEZING: '냉동',
};

// 문의 유형
const INQUIRY_SUB_TYPE = {
  // DELIVERY: '배송',
  // BULK: '대량문의',
  // ORDER: '주문/결제',
  // DETAIL: '상세',
  // RESTOCK: '재입고',
  // ETC: '기타',

  // 1:1 문의
  // JM_PAY: 'JM페이 관련', // 제이엠페이 관련
  // JM_PAY_REFUND: 'JM페이 환불 신청', // 환불 신청
  // USER: '회원정보', // 회원정보
  SERVICE: '서비스', // 서비스

  // 공통 문의
  DELIVERY: '배송', // 배송
  BULK: '대량문의', // 대량문의
  ORDER: '주문/결제', // 주문/결제
  ETC: '기타', //기타
  // STORE: '매장', //매장

  // 상품 관련
  DETAIL: '상세', // 상세
  RESTOCK: '재입고', // 재입고
};

const { TextArea } = Input;

const PAGE_SIZE = 5;
const PAGE_COUNT = 5;

const ProductDetailPresenter = (props) => {
  /* ===== PROPS ===== */
  const {
    layoutRef,
    contentRef,
    //
    user,
    tabItems,
    tabKey,
    product,
    information,
    reviews,
    inquiries,
    selectedProduct,
    productOptions,
    selectedOption,
    isWish,
    isRestock,
    isMore,
    regularCycle,
    inputValue,
    files,
    isLoading,
    maxFileCount,
    maxFileSize,
    downloadCoupon,
    selectedRentalOption,
    onSelectRentalOption,
    //
    setRegularCycle,
    onTabKey,
    navigate,
    onSubmit,
    onProductList,
    onOptionSelect,
    setIsMore,
    onReception,
    onChange,
    onFileList,
    onCopyUrl,
    onCouponDownload,
    location,
    calculateTotalOptionPrice,
    screenSize,
    agentType,
  } = props;
  /* ===== STATE ===== */
  const fileInputRef = React.useRef(null);
  const [swiper, setSwiper] = useState(null);

  const [currentReviewPage, setCurrentReviewPage] = React.useState(1);
  const [currentInquiryPage, setCurrentInquiryPage] = React.useState(1);

  // 총 상품 금액
  const [totalPrice, setTotalPrice] = useState(0);
  //문의하기 모달창
  const [isInquiryModalOpen, setIsInquiryModalOpen] = useState(false);
  //사진 전체보기
  const [isPhotoModalOpen, setIsPhotoModalOpen] = useState(false);
  const [reviewDetail, setReviewDetail] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [, setVisibleImages] = useState(8);
  //
  const [activeIndex, setActiveIndex] = React.useState(0);
  // 스토어 픽업/렌탈 모달
  const [isOpened, setIsOpened] = React.useState(null);
  // 픽업 매장
  const [selectPickupStore, setSelectPickupStore] = React.useState(null);

  // 렌탈 월 결제금액
  const [rentalPrice, setRentalPrice] = React.useState(0);

  // 모바일 옵션 모달
  const [isOpen, setIsOpen] = useState(false);

  // 상품설명 높이
  const con = React.useRef(null);
  const [contentHeight, setContentHeight] = React.useState(0);

  // sticky
  const stickyRef = React.useRef(null);
  const [isSticky, setIsSticky] = React.useState(false);

  //뒤로가기로 모달 닫기
  React.useEffect(() => {
    const handleBackButton = () => {
      if (isInquiryModalOpen) {
        setIsInquiryModalOpen(false);
        return;
      }
      if (isPhotoModalOpen) {
        setIsPhotoModalOpen(false);
        return;
      }
      if (reviewDetail) {
        setReviewDetail(false);
        return;
      }
      if (isOpened) {
        setIsOpened(false);
        return;
      }
      if (isOpen) {
        setIsOpen(false);
        return;
      }

      // 모든 모달이 닫힌 상태라면 히스토리를 원래 상태로 되돌림
      window.history.replaceState(null, '', window.location.href);
    };

    const handlePopState = () => {
      handleBackButton();
    };

    // 모달이 열릴 때 히스토리 추가
    if (isInquiryModalOpen || isPhotoModalOpen || isOpened || isOpen) {
      window.history.pushState(null, '', window.location.href);
    }

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isInquiryModalOpen, isPhotoModalOpen, isOpened, isOpen, reviewDetail]);

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: screenSize >= 768 ? 24 : 16,
      color: 'var(--black-color)',
      lineHeight: '180%',
    },

    swiperButton: {
      width: 20,
      height: 20,
      padding: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#DDDDDD',
      fontSize: 12,
    },

    infoText: {
      display: 'flex',
      alignItems: 'stretch',
      fontSize: screenSize >= 768 ? 16 : 14,
      fontWeight: 400,
      lineHeight: '180%',
      color: 'var(--black-color)',
    },

    paginationButton: {
      border: '1px solid var(--black-color)',
      color: 'var(--black-color)',
      width: 48,
      height: 48,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
    },

    bullet: {
      width: 60,
      display: 'inline-block',
      cursor: 'pointer',
    },

    select: {
      width: '100%',
      height: 48,
      fontSize: 16,
    },

    amountButton: {
      width: 28,
      height: 28,
      borderRadius: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderColor: 'var(--light-gray-color)',
      color: 'var(--black-color)',
    },

    button: {
      borderRadius: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: screenSize >= 768 ? 18 : 14,
      fontWeight: 700,
    },

    optionWrap: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    optionContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    option: {
      flex: 1,
    },
    optionTitle: {
      fontSize: 12,
      fontWeight: 400,
      color: '#999999',
    },

    shareButton: {
      border: 'none',
      background: 'none',
      cursor: 'pointer',
      fontSize: 20,
      color: '#999999',
    },

    prefix: {
      paddingRight: 8,
    },
    pre: {
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
    },
    wonsize: {
      fontSize: screenSize >= 768 ? 20 : 14,
    },

    titleStyle: {
      minWidth: 100,
      alignItems: 'flex-start',
    },
  };

  /* ===== FUNCTION ===== */
  //문의하기 모달창
  const showInquiryModal = () => {
    if (!user) {
      const confirm = window.confirm(
        '로그인 후 이용가능합니다.\n로그인하시겠습니까?'
      );

      if (confirm) {
        return navigate('signin', {
          state: {
            from: `${location.pathname}${
              location.search ? location.search : ''
            }`,
          },
        });
      } else {
        return;
      }
    }

    setIsInquiryModalOpen(true);
  };

  const closeInquiryModal = () => {
    setIsInquiryModalOpen(false);
  };

  const showPhotoModal = () => {
    setIsPhotoModalOpen(true);
  };

  const closePhotoModal = () => {
    setIsPhotoModalOpen(false);
    setReviewDetail(null);
    setVisibleImages(8); // 모달 닫을 때 초기화
  };

  const handleReviewDetail = (reviewId) => {
    setIsPhotoModalOpen(true);
    const matchedReview = reviews.reviews?.find(
      (r) => r.review_id === reviewId
    );
    setReviewDetail(matchedReview);
    setSelectedImage(matchedReview?.review_img[0]);
  };
  /* ===== HOOKS ===== */
  /**
   * 총합금액 계산
   * --
   */
  console.log('selectedProduct ===>', selectedProduct);
  React.useEffect(() => {
    const total = selectedProduct.reduce((acc, cur) => {
      const {
        cartNum,
        price,
        product_option,
        apply_grade_benefit,
        apply_policy,
      } = cur;

      // 옵션 가격 계산
      const totalOptionPrice = calculateTotalOptionPrice(product_option);

      const { final_discount_price } = calculateApplyPolicy(
        {
          price,
          option_price: totalOptionPrice,
          num: cartNum,
        },
        apply_grade_benefit,
        apply_policy
      );

      const originTotal = (price + totalOptionPrice) * cartNum;

      // 총 가격 계산
      return acc + (originTotal - final_discount_price);
    }, 0);

    setTotalPrice(total);
    // eslint-disable-next-line
  }, [selectedProduct]);

  // 사진 데이터 (Product 이미지를 사용)
  const Photos = React.useMemo(() => {
    if (!reviews.photo) return [];

    const photoList = reviews.photo.reduce((acc, cur) => {
      acc = acc.concat(cur.review_img);

      return acc;
    }, []);

    return photoList;
  }, [reviews.photo]);

  /**
   * 픽업지 초기값
   * --
   */
  React.useEffect(() => {
    if (!product) return;

    const { pickup, is_store_pickup } = product;

    if (is_store_pickup === 'Y' && pickup?.length) {
      setSelectPickupStore(pickup[0]);
    }
  }, [product]);

  /**
   * 렌탈 금액 계산
   * --
   */
  React.useEffect(() => {
    const montlyAmount = calculateRentalMonthlyPayment(
      totalPrice,
      selectedRentalOption
    );

    setRentalPrice(montlyAmount);
  }, [totalPrice, selectedRentalOption]);

  /**
   * 상품설명 높이
   * --
   */
  React.useEffect(() => {
    const node = con.current;

    if (!node) return;

    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const newHeight = entry.contentRect.height;
        setContentHeight(newHeight);
      }
    });

    observer.observe(node);

    return () => {
      observer.unobserve(node);
    };
  }, [product]);

  /**
   * Sticky 되는 시점 감지
   * --
   */
  React.useEffect(() => {
    const marker = stickyRef.current;

    if (!marker) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // marker가 뷰포트에서 사라지면 sticky 상태로 추정
        setIsSticky(!entry.isIntersecting);
      },
      { root: null, threshold: 0 }
    );

    observer.observe(marker);
    return () => {
      observer.disconnect();
    };
  }, []);

  /* ===== RENDER ===== */
  return (
    <React.Fragment>
      <div ref={layoutRef}>
        <Content
          maxWidth={1820}
          padding={0}
          style={{ paddingBottom: screenSize >= 768 ? 200 : 80 }}
          className="productdetail"
        >
          <Row>
            <Col x={24}>
              {/* 상품 정보 */}
              <Row gutter={16}>
                <Col x={1} xl={2} xxl={4}></Col>
                <Col x={22} xl={12} xxl={10}>
                  <Content maxWidth={705} padding={0}>
                    {/* SECTION: 이미지 슬라이더 */}
                    <Content
                      maxWidth={'100%'}
                      padding={0}
                      style={{
                        position: 'relative',
                        top:
                          screenSize >= 785 ? 60 : screenSize >= 785 ? 30 : 0,
                        left: 0,
                        marginBottom:
                          screenSize >= 768 ? 120 : screenSize >= 500 ? 40 : 0,
                      }}
                    >
                      <Slider
                        items={
                          product?.files?.length
                            ? product?.files
                            : new Array(1).fill(null)
                        }
                        modules={['Autoplay', 'Pagination']}
                        centeredSlides={true}
                        loop={true}
                        initialSlide={0}
                        slidesPerView={1}
                        autoplay={{
                          delay: 2000,
                          disableOnInteraction: false,
                        }}
                        itemStyle={{ aspectRatio: '4 / 5' }}
                        render={(state) => (
                          <Image src={state} width={'100%'} height={'100%'} />
                        )}
                        onSwiper={(swiper) => {
                          setSwiper(swiper);
                          swiper.slideToLoop(0, 0); // 초기화 시 첫 번째 슬라이드로 강제 이동
                        }}
                        onSlideChange={(swiper) =>
                          setActiveIndex(swiper.realIndex)
                        }
                      />

                      {product?.files?.length ? (
                        <ul
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: -68,
                            display: screenSize >= 1200 ? 'flex' : 'none',
                            flexDirection: 'column',
                            gap: '6px',
                          }}
                        >
                          {product?.files?.map((_item, _index) => (
                            <li
                              key={_index}
                              onClick={() => swiper.slideToLoop(_index)}
                              style={{
                                ...styles.bullet,
                                border:
                                  activeIndex === _index
                                    ? '1px solid var(--black-color)'
                                    : '1px solid transparent',
                              }}
                            >
                              <Image
                                src={_item}
                                width={'100%'}
                                height={'100%'}
                                alt={`image_${_index}`}
                              />
                            </li>
                          ))}
                        </ul>
                      ) : null}
                    </Content>

                    {/* ===== 모바일용 상품 가격 ===== */}
                    <Content
                      maxWidth={'100%'}
                      padding={0}
                      style={{
                        display: screenSize >= 1200 ? 'none' : 'block',
                      }}
                    >
                      <Content
                        maxWidth={'100%'}
                        padding={0}
                        style={{
                          borderBottom: '1px solid #111111',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            fontSize: screenSize >= 768 ? 16 : 14,
                            fontWeight: 400,
                            lineHeight: '28px',
                            color: 'var(--black-color)',
                            marginTop: 20,
                          }}
                        >
                          <p>
                            {product?.shop_information?.shop_information_name}{' '}
                            {product?.shop_information?.is_brand === 'Y' ? (
                              <span>
                                <img
                                  src={more}
                                  alt="more icon"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() =>
                                    navigate(
                                      `/brand/${encodeURIComponent(
                                        encrypt(
                                          product?.shop_information
                                            ?.shop_information_id
                                        )
                                      )}`
                                    )
                                  }
                                />
                              </span>
                            ) : null}
                          </p>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '24px',
                            }}
                          >
                            <button
                              style={{ ...styles.shareButton }}
                              onClick={() =>
                                onSubmit(isWish ? 'remove' : 'wishlist')
                              }
                            >
                              {isWish ? (
                                <HeartFilled style={{ color: '#D33444' }} />
                              ) : (
                                <HeartOutlined />
                              )}
                            </button>
                            <button
                              style={{ ...styles.shareButton }}
                              onClick={() => onCopyUrl()}
                            >
                              <ShareAltOutlined />
                            </button>
                          </div>
                        </div>
                        <Text
                          size={
                            screenSize >= 768 ? 32 : screenSize >= 500 ? 20 : 18
                          }
                          weight={700}
                          style={{
                            marginTop: screenSize >= 768 ? 24 : 12,
                            wordBreak: 'keep-all',
                          }}
                          maxLine={3}
                        >
                          {product?.product_name}
                        </Text>
                        {/* SECTION: 상품 가격 */}
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginTop: screenSize >= 768 ? 20 : 10,
                          }}
                        >
                          {product?.discount_rate ? (
                            <div>
                              <Text
                                size={screenSize >= 768 ? 18 : 14}
                                weight={400}
                                color={'#BBBBBB'}
                                style={{
                                  textDecoration: 'line-through',
                                  marginBottom: 4,
                                  display: 'flex',
                                }}
                              >
                                {product?.type === 'RENTAL' ? (
                                  <small style={{ ...styles.prefix }}>월</small>
                                ) : (
                                  ''
                                )}
                                {stringToMoneyFormat(
                                  product?.type === 'RENTAL'
                                    ? product?.monthlyPrice
                                    : product?.price
                                )}
                                <div style={{ ...styles.wonsize }}>원</div>
                              </Text>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  flexDirection:
                                    product?.discount_type === 'W'
                                      ? 'row-reverse'
                                      : 'row',
                                }}
                              >
                                <Text
                                  weight={700}
                                  color={'var(--danger-color)'}
                                  style={{
                                    paddingRight: 12,
                                    lineHeight:
                                      product?.discount_type === 'W'
                                        ? screenSize >= 768
                                          ? '260%'
                                          : '190%'
                                        : '150%',
                                    fontSize:
                                      product?.discount_type === 'W' ? 13 : 18,
                                  }}
                                >
                                  {product?.discount_type === 'W'
                                    ? `(${stringToMoneyFormat(
                                        product?.discount_rate
                                      )}원 할인)`
                                    : `${product?.apply_discount_rate}%`}
                                </Text>
                                <Text
                                  size={screenSize >= 768 ? 28 : 18}
                                  weight={700}
                                  style={{ display: 'flex' }}
                                >
                                  {product?.type === 'RENTAL' ? (
                                    <small style={{ ...styles.prefix }}>
                                      월
                                    </small>
                                  ) : (
                                    ''
                                  )}
                                  {stringToMoneyFormat(
                                    product?.type === 'RENTAL'
                                      ? product?.finalMonthlyPrice
                                      : product?.finalPrice
                                  )}
                                  <div style={{ ...styles.wonsize }}>원</div>
                                </Text>

                                <ProductItem.Policies
                                  policies={product?.policies}
                                />
                              </div>
                            </div>
                          ) : (
                            <Text
                              size={screenSize >= 768 ? 28 : 18}
                              weight={700}
                              style={{ paddingRight: 12, display: 'flex' }}
                            >
                              {product?.type === 'RENTAL' ? (
                                <small style={{ ...styles.prefix }}>월</small>
                              ) : (
                                ''
                              )}
                              {stringToMoneyFormat(
                                product?.type === 'RENTAL'
                                  ? product?.finalMonthlyPrice
                                  : product?.finalPrice
                              )}
                              <div style={{ ...styles.wonsize }}>원</div>
                            </Text>
                          )}
                        </div>
                        {/* SECTION: 태그 */}
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginTop: 24,
                          }}
                        >
                          {product?.tag?.length ? (
                            <ProductItem.Tags
                              tags={product?.tag.map((tag) => ({
                                id: tag.tag_id,
                                label: tag.tag_name,
                              }))}
                              style={{ flexWrap: 'wrap', marginBottom: 32 }}
                            />
                          ) : null}
                        </div>
                      </Content>

                      {/* SECTION: 배송 정보 */}
                      <Content
                        maxWidth={'100%'}
                        padding={screenSize >= 768 ? '32px 0' : '20px 0'}
                        style={{ borderBottom: '1px solid #EEEEEE' }}
                      >
                        <div>
                          {[
                            // {
                            //   title: '타임세일',
                            //   content: (
                            //     <p style={{ color: 'var(--danger-color)' }}>
                            //       남은 시간 12일 19:04:54 (12,000원 할인)
                            //     </p>
                            //   ),
                            // },
                            ...(downloadCoupon
                              ? [
                                  {
                                    title: '쿠폰',
                                    content: (
                                      <div
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          gap: 10,
                                        }}
                                      >
                                        {downloadCoupon.map((coupon) => (
                                          <div
                                            style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center',
                                            }}
                                          >
                                            <div style={{ flex: 1 }}>
                                              <Text>{coupon.coupon_name}</Text>
                                              <Text size={12} color={'#999999'}>
                                                {coupon.start_date
                                                  ? Formatter.unixToDate(
                                                      coupon.start_date,
                                                      'YYYY.MM.DD'
                                                    )
                                                  : ''}
                                                {coupon.start_date ||
                                                coupon.end_date
                                                  ? ' ~ '
                                                  : ''}
                                                {coupon.end_date
                                                  ? Formatter.unixToDate(
                                                      coupon.end_date,
                                                      'YYYY.MM.DD'
                                                    )
                                                  : ''}
                                              </Text>
                                            </div>
                                            <button
                                              style={{
                                                cursor:
                                                  coupon.isDownload === 'Y'
                                                    ? 'default'
                                                    : 'pointer',
                                                background: 'none',
                                                border: 'none',
                                              }}
                                              disabled={
                                                coupon.isDownload === 'Y'
                                                  ? true
                                                  : false
                                              }
                                              onClick={() =>
                                                onCouponDownload(
                                                  coupon.coupon_code
                                                )
                                              }
                                            >
                                              {coupon.isDownload === 'Y' ? (
                                                <Text
                                                  size={12}
                                                  color={'#DDDDDD'}
                                                >
                                                  발급완료
                                                </Text>
                                              ) : (
                                                <img
                                                  src={Download}
                                                  alt="다운로드"
                                                />
                                              )}
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                    ),
                                    wrapStyle: { alignItems: 'stretch' },
                                    contentStyle: { flex: 1 },
                                  },
                                ]
                              : []),
                            {
                              title: product?.type !== 'AMOUNT' ?? '택배사',
                              content:
                                product?.type !== 'AMOUNT' ??
                                (product?.forwarding_location
                                  ? `${
                                      DELIVERY_METHOD[
                                        product?.forwarding_location
                                          ?.delivery_method
                                      ]
                                    } (${
                                      CONSTANTS.DELIVERY_COMPANY[
                                        product?.forwarding_location
                                          ?.delivery_company
                                      ]?.label
                                    })`
                                  : '-'),
                            },
                            {
                              title: product?.type !== 'AMOUNT' ?? '배송정보',
                              content:
                                product?.type !== 'AMOUNT' ??
                                (product?.forwarding_date
                                  ? `${product?.forwarding_date}일 이내 출고`
                                  : '당일 출고'),
                            },
                            {
                              title: product?.type !== 'AMOUNT' ?? '배송비',
                              content:
                                product?.type !== 'AMOUNT' ??
                                `${stringToMoneyFormat(
                                  product?.forwarding_location?.delivery_price
                                )}원${
                                  product?.forwarding_location
                                    ?.free_delivery_price
                                    ? ` (${stringToMoneyFormat(
                                        product?.forwarding_location
                                          ?.free_delivery_price
                                      )}원 이상 무료배송)`
                                    : ''
                                }`,
                            },
                            {
                              title: product?.type !== 'AMOUNT' ?? '포장타입',
                              content:
                                product?.type !== 'AMOUNT' ??
                                `${PACKAGE_METHOD[product?.packaging_method]}`,
                            },
                            ...(product?.reserve_rate
                              ? [
                                  {
                                    title: '적립',
                                    content: `+ ${stringToMoneyFormat(
                                      calculateDiscount(
                                        product?.finalPrice,
                                        product?.policy
                                      ).reserve,
                                      'P'
                                    )}`,
                                  },
                                ]
                              : []),
                            ...(product?.payment_additional_information
                              ? Object.entries(
                                  product?.payment_additional_information
                                )?.map(([key, value]) => ({
                                  title: key,
                                  content: value,
                                }))
                              : []),
                          ].map((_item, _index) => (
                            <div
                              key={`payment_info_${_index}`}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: screenSize >= 768 ? 16 : 14,
                                fontWeight: 400,
                                lineHeight: '24px',
                                color: 'var(--black-color)',
                                marginBottom: screenSize >= 768 ? 16 : 12,
                                ...styles.wrapStyle,
                              }}
                            >
                              <div
                                style={{
                                  width: 100,
                                  fontWeight: 'unset',
                                  color: '#777',
                                  ...styles.titleStyle,
                                }}
                              >
                                {_item.title}
                              </div>
                              <div style={{ ...styles.contentStyle }}>
                                {_item.content}
                              </div>
                            </div>
                          ))}
                        </div>
                      </Content>

                      {/* SECTION 상품 옵션 */}
                      <Content maxWidth={'100%'} padding={0}>
                        <Content
                          maxWidth={'100%'}
                          padding={screenSize >= 768 ? '28px 0px' : '20px 0'}
                        >
                          <div>
                            <div style={{ ...styles.optionWrap }}>
                              {productOptions &&
                              productOptions.REQUIRED.length ? (
                                <React.Fragment>
                                  <p style={{ ...styles.optionTitle }}>
                                    필수옵션
                                  </p>
                                  <div style={{ ...styles.optionContainer }}>
                                    {productOptions.REQUIRED.map(
                                      (option, index) => {
                                        const findSelect = selectedOption.find(
                                          (select) =>
                                            select.option_id.toString() ===
                                            option.key
                                        );
                                        return (
                                          <Select
                                            key={`REQUIRED_${index}`}
                                            placeholder={`${option.title}`}
                                            options={option.children}
                                            style={{ ...styles.option }}
                                            size="large"
                                            onChange={(e) =>
                                              onOptionSelect('REQUIRED', e)
                                            }
                                            value={
                                              findSelect
                                                ? `${findSelect.option_id}-${findSelect.option.option_key}`
                                                : null
                                            }
                                            disabled={
                                              index === 0 ||
                                              (index !== 0 &&
                                                selectedOption[index - 1])
                                                ? false
                                                : true
                                            }
                                          />
                                        );
                                      }
                                    )}
                                  </div>
                                </React.Fragment>
                              ) : null}
                              {productOptions &&
                              productOptions.ADDITION.length ? (
                                <React.Fragment>
                                  <p
                                    style={{
                                      ...styles.optionTitle,
                                      marginTop: 8,
                                    }}
                                  >
                                    추가옵션
                                  </p>
                                  <div style={{ ...styles.optionContainer }}>
                                    {productOptions.ADDITION.map(
                                      (option, index) => {
                                        const findSelect = selectedOption.find(
                                          (select) =>
                                            select.option_id.toString() ===
                                            option.key
                                        );
                                        return (
                                          <Select
                                            key={`ADDITION_${index}`}
                                            placeholder={`${option.title}`}
                                            options={option.children}
                                            style={{ ...styles.option }}
                                            size="large"
                                            onChange={(e) =>
                                              onOptionSelect('ADDITION', e)
                                            }
                                            value={
                                              findSelect
                                                ? `${findSelect.option_id}-${findSelect.option.option_key}`
                                                : null
                                            }
                                          />
                                        );
                                      }
                                    )}
                                  </div>
                                </React.Fragment>
                              ) : null}
                              {product?.type === 'SUBSCRIPTION' ? (
                                <React.Fragment>
                                  <Flex vertical gap={4}>
                                    <div>
                                      <p style={{ ...styles.optionTitle }}>
                                        배송주기
                                      </p>
                                      <div
                                        style={{ ...styles.optionContainer }}
                                      >
                                        <Select
                                          placeholder={`배송주기를 선택해주세요`}
                                          options={
                                            product?.regular_information
                                              ?.regular_cycle
                                          }
                                          style={{ ...styles.option }}
                                          size="large"
                                          value={regularCycle?.regular_cycle}
                                          onChange={(e) =>
                                            setRegularCycle((prev) => ({
                                              ...prev,
                                              regular_cycle: e,
                                            }))
                                          }
                                        />
                                      </div>
                                    </div>

                                    <div>
                                      <p style={{ ...styles.optionTitle }}>
                                        배송횟수
                                      </p>
                                      <div
                                        style={{ ...styles.optionContainer }}
                                      >
                                        <Select
                                          placeholder={`배송횟수를 선택해주세요`}
                                          options={product?.regular_information?.max_regular_delivery_count
                                            ?.split(':')
                                            ?.map((item) => ({
                                              label:
                                                Number(item) === 0
                                                  ? '제한없음'
                                                  : `${item}회`,
                                              value: Number(item),
                                            }))}
                                          style={{ ...styles.option }}
                                          size="large"
                                          value={
                                            regularCycle?.max_regular_delivery_count
                                          }
                                          onChange={(e) =>
                                            setRegularCycle((prev) => ({
                                              ...prev,
                                              max_regular_delivery_count: e,
                                            }))
                                          }
                                        />
                                      </div>
                                    </div>
                                  </Flex>
                                </React.Fragment>
                              ) : null}
                              {(productOptions &&
                                productOptions.REQUIRED.length) ||
                              product?.type === 'SUBSCRIPTION' ? (
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                  }}
                                >
                                  {product?.type === 'RENTAL' &&
                                  selectedProduct.length ? null : (
                                    <Button
                                      style={{
                                        borderRadius: 0,
                                        marginTop: 8,
                                        width: 80,
                                        fontSize: screenSize >= 768 ? 16 : 14,
                                      }}
                                      onClick={() =>
                                        onProductList('ADD', 0, {
                                          ...product,
                                          cartNum: 1,
                                          ...regularCycle,
                                        })
                                      }
                                    >
                                      담기
                                    </Button>
                                  )}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div
                            style={{
                              borderBottom: '1px solid var(--black-color)',
                              padding:
                                screenSize >= 768 ? '28px 0px' : '20px 0',
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '20px',
                            }}
                          >
                            {selectedProduct.map((_item, _index) => {
                              const { product_option } = _item;
                              const optionName = !product_option
                                ? ''
                                : product_option.reduce((acc, cur, index) => {
                                    const optionName =
                                      cur.option[0].option_name;
                                    return (acc += `${
                                      index ? ' / ' : ''
                                    }${optionName}`);
                                  }, '');
                              return (
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: '20px',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '6px',
                                      flex: 1,
                                    }}
                                  >
                                    <div style={{ flex: 1 }}>
                                      <Text
                                        size={screenSize >= 768 ? 16 : 14}
                                        weight={400}
                                      >
                                        {_item.product_name}{' '}
                                        {_item?.type === 'SUBSCRIPTION'
                                          ? `(${
                                              REGULAR_OPTION.find(
                                                (option) =>
                                                  option.value ===
                                                  _item.regular_cycle
                                              ).label
                                            }, ${
                                              _item?.max_regular_delivery_count ===
                                              0
                                                ? '제한없음'
                                                : `${_item?.max_regular_delivery_count}회`
                                            })`
                                          : null}
                                      </Text>
                                      <Text size={12} color={'#999999'}>
                                        {optionName}
                                      </Text>
                                    </div>
                                    {product_option?.length ||
                                    _item.regular_cycle ? (
                                      <button
                                        style={{
                                          width: 18,
                                          height: 18,
                                          border: 'none',
                                          cursor: 'pointer',
                                          background: '#EEEEEE',
                                          borderRadius: '50%',
                                        }}
                                        onClick={() =>
                                          onProductList('REMOVE', _index)
                                        }
                                      >
                                        <img src={IconX} alt="remove" />
                                      </button>
                                    ) : null}
                                  </div>
                                  {product.type === 'RENTAL' ? null : (
                                    <Modifier
                                      init={_item.cartNum}
                                      minNum={1}
                                      maxNum={99}
                                      unit={null}
                                      layoutStyle={{
                                        width: 122,
                                        height: 36,
                                        background: 'none',
                                        border: 'none',
                                      }}
                                      buttonStyle={{
                                        border: 'none',
                                      }}
                                      onDecrease={() =>
                                        onProductList(
                                          'UPDATE',
                                          _index,
                                          --_item.cartNum
                                        )
                                      }
                                      onIncrease={() =>
                                        onProductList(
                                          'UPDATE',
                                          _index,
                                          ++_item.cartNum
                                        )
                                      }
                                      readOnly
                                    />
                                  )}
                                </div>
                              );
                            })}
                          </div>
                          {product?.type === 'RENTAL' ? null : (
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                                marginTop: screenSize >= 768 ? 28 : 20,
                                gap: '12px',
                              }}
                            >
                              <Text size={screenSize >= 768 ? 16 : 14}>
                                총 상품 금액
                              </Text>
                              <Text
                                size={screenSize >= 768 ? 32 : 20}
                                weight={700}
                                color={'var(--danger-color)'}
                              >
                                {stringToMoneyFormat(totalPrice)}
                              </Text>
                            </div>
                          )}
                        </Content>
                        <Content maxWidth={'100%'} padding={0}>
                          {product?.type !== 'RENTAL' ? (
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '8px',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  width: '100%',
                                  gap: '8px',
                                }}
                              >
                                {product?.is_present === 'Y' ? (
                                  <Button
                                    type="secondary"
                                    style={{
                                      ...styles.button,
                                      width: 64,
                                      height: screenSize >= 768 ? 64 : 40,
                                    }}
                                    onClick={() => {
                                      if (product?.isSoldOut === 'Y') {
                                        MessageAlert.info('품절상품입니다.');
                                        return;
                                      }
                                      onSubmit('present', product.product_id);
                                    }}
                                  >
                                    <img src={Gift} alt="선물하기" />
                                  </Button>
                                ) : null}
                                {product?.type !== 'AMOUNT' && (
                                  <Button
                                    type="secondary"
                                    style={{
                                      ...styles.button,
                                      height: screenSize >= 768 ? 64 : 40,
                                      flex: 1,
                                    }}
                                    onClick={async () => {
                                      await onSubmit('cart').then((res) => {
                                        if (!res) return;
                                        const confirm = window.confirm(
                                          '장바구니에 추가되었습니다. 장바구니로 이동하시겠습니까?'
                                        );
                                        if (confirm) {
                                          navigate(
                                            `/order/cart?type=${product.type.toLocaleLowerCase()}`
                                          );
                                        } else {
                                          return;
                                        }
                                      });
                                    }}
                                  >
                                    장바구니
                                  </Button>
                                )}
                                {product?.type === 'AMOUNT' ??
                                  (product?.is_store_pickup === 'Y' ? (
                                    <Button
                                      type="secondary"
                                      style={{
                                        ...styles.button,
                                        height: screenSize >= 768 ? 64 : 40,
                                        flex: 1,
                                      }}
                                      onClick={() => {
                                        if (!selectedProduct.length) {
                                          MessageAlert.warning(
                                            '구매하실 상품을 선택해주세요!'
                                          );
                                          return;
                                        }
                                        setIsOpened('PICKUP');
                                      }}
                                    >
                                      매장픽업
                                    </Button>
                                  ) : product?.isSoldOut === 'Y' ? (
                                    <Button
                                      style={{
                                        ...styles.button,
                                        height: screenSize >= 768 ? 64 : 40,
                                        flex: 1,
                                        background:
                                          product?.is_restocking_notification ===
                                          'N'
                                            ? '#DDDDDD'
                                            : '#111111',
                                      }}
                                      disabled={
                                        product?.is_restocking_notification ===
                                        'N'
                                          ? true
                                          : false
                                      }
                                      onClick={() =>
                                        onSubmit(
                                          isRestock
                                            ? 'unsubscribe'
                                            : 'subscribe'
                                        )
                                      }
                                    >
                                      {product?.is_restocking_notification ===
                                      'Y'
                                        ? isRestock
                                          ? '재입고알림 해지'
                                          : '재입고알림'
                                        : '품절'}
                                    </Button>
                                  ) : (
                                    <Button
                                      style={{
                                        ...styles.button,
                                        height: screenSize >= 768 ? 64 : 40,
                                        flex: 1,
                                        background: '#111111',
                                      }}
                                      disabled={false}
                                      onClick={async () => {
                                        await onSubmit('cart').then((res) => {
                                          if (!res) return;
                                          navigate(
                                            `/order/cart?type=${product.type.toLocaleLowerCase()}`
                                          );
                                        });
                                      }}
                                    >
                                      바로구매
                                    </Button>
                                  ))}
                              </div>
                              {product?.type === 'AMOUNT' ??
                                (product?.is_store_pickup === 'Y' ? (
                                  <Button
                                    style={{
                                      ...styles.button,
                                      width: '100%',
                                      height: screenSize >= 768 ? 64 : 40,
                                    }}
                                    onClick={async () => {
                                      await onSubmit('cart').then((res) => {
                                        if (!res) return;
                                        navigate('/order/cart');
                                      });
                                    }}
                                  >
                                    바로구매
                                  </Button>
                                ) : null)}
                            </div>
                          ) : (
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '8px',
                              }}
                            >
                              <Button
                                style={{
                                  ...styles.button,
                                  width: '100%',
                                  height: screenSize >= 768 ? 64 : 40,
                                }}
                                onClick={() => {
                                  if (
                                    !selectedProduct ||
                                    !selectedProduct.length
                                  )
                                    return MessageAlert.info(
                                      '상품 옵션을 선택해주세요.'
                                    );
                                  setIsOpened('RENTAL');
                                }}
                              >
                                렌탈 계약 조건 선택
                              </Button>
                            </div>
                          )}
                          {product?.type === 'AMOUNT' ?? (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginTop: screenSize >= 500 ? 28 : 15,
                                gap: '8px',
                              }}
                            >
                              <Button
                                type="secondary"
                                style={{
                                  ...styles.button,
                                  width: '100%',
                                  height: screenSize >= 768 ? 64 : 40,
                                  paddingLeft: 0,
                                  fontSize: screenSize >= 500 ? 15 : 12,
                                  background: 'var(--naver-color)',
                                  borderColor: 'var(--naver-color)',
                                }}
                                onClick={() => onSubmit('naver_pay')}
                              >
                                <img
                                  src={Naver}
                                  alt="Naver Pay"
                                  width={screenSize >= 768 ? 'unset' : 30}
                                />
                                네이버 pay 구매
                              </Button>
                              <Button
                                type="secondary"
                                style={{
                                  ...styles.button,
                                  width: '100%',
                                  height: screenSize >= 768 ? 64 : 40,
                                  paddingLeft: 0,
                                  fontSize: screenSize >= 500 ? 15 : 12,
                                  background: 'var(--kakao-color)',
                                  borderColor: 'var(--kakao-color)',
                                }}
                                onClick={() => onSubmit('kakao_pay')}
                              >
                                <img
                                  src={Kakao}
                                  alt="Kakao Pay"
                                  width={screenSize >= 768 ? 'unset' : 30}
                                />
                                카카오 pay 구매
                              </Button>
                            </div>
                          )}
                        </Content>
                      </Content>
                    </Content>
                    {/* ===== 모바일용 상품 가격 ===== */}

                    {/* SECTION: 상품 정보 */}
                    <Content maxWidth={'100%'} padding={0}>
                      <div
                        ref={(el) => (contentRef.current = el)}
                        style={{
                          position: 'sticky',
                          top:
                            screenSize >= 768
                              ? 148
                              : agentType === 'WEBVIEW'
                              ? 60
                              : 123,
                          width: contentRef.current?.clientWidth,
                          zIndex: 10,
                          marginTop: screenSize >= 768 ? 0 : 30,
                        }}
                      >
                        <Tabs
                          items={tabItems}
                          activeKey={tabKey}
                          onChange={onTabKey}
                          style={{
                            padding: 0,
                            width: '25%',
                            background: 'var(--white-color)',
                            margin: 0,
                          }}
                          textStyle={{
                            padding: screenSize >= 768 ? 18 : '12px 3px',
                            fontSize: screenSize >= 768 ? 18 : 14,
                            fontWeight: 700,
                            lineHeight: '30px',
                            textAlign: 'center',
                            color: 'var(--dark-gray-color)',
                          }}
                          activeColor={'var(--black-color)'}
                        />
                      </div>

                      <Content
                        maxWidth={'100%'}
                        padding={0}
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: screenSize >= 768 ? 140 : 40,
                        }}
                      >
                        {/* SECTION: Content */}
                        <div
                          ref={(el) => (contentRef['content'] = el)}
                          style={{ marginTop: 40 }}
                          onLoad={() => console.log('로드됨')}
                        >
                          <div
                            ref={con}
                            style={{
                              maxHeight: isMore ? 'none' : 1000,
                              overflow: 'hidden',
                              position: 'relative',
                              top: 0,
                              left: 0,
                            }}
                          >
                            <HtmlContent content={product?.product_content} />
                            {contentHeight > 705 && !isMore ? (
                              <div
                                style={{
                                  position: 'absolute',
                                  bottom: 0,
                                  width: '100%',
                                  background:
                                    'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 80%)',
                                  zIndex: 1,
                                  height: 705,
                                  display: 'flex',
                                  alignItems: 'flex-end',
                                }}
                              >
                                <p
                                  onClick={() => setIsMore(!isMore)}
                                  style={{
                                    fontSize: screenSize >= 768 ? 16 : 14,
                                    fontWeight: 600,
                                    color: '#111111',
                                    height: screenSize >= 768 ? 64 : 40,
                                    width: '100%',
                                    border: '1px solid #111111',
                                    background: '#FFFFFF',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    gap: 5,
                                  }}
                                >
                                  상품 정보 더 보기 <DownOutlined />
                                </p>
                              </div>
                            ) : null}
                          </div>
                        </div>
                        {/* Content 끝 */}

                        {/* SECTION: Detail */}
                        <div ref={(el) => (contentRef['detail'] = el)}>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: screenSize >= 768 ? 140 : 40,
                            }}
                          >
                            {information.map((_item, _index) => (
                              <div key={`information_${_item.title}_${_index}`}>
                                <Title
                                  style={{
                                    ...styles.title,
                                    paddingBottom: screenSize >= 768 ? 32 : 20,
                                    borderBottom:
                                      '2px solid var(--black-color)',
                                  }}
                                >
                                  {_item.title}
                                </Title>
                                {_item.children.map((_subitem, _subindex) => (
                                  <div
                                    key={`information_${_subitem.title}_${_subindex}`}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'stretch',
                                      flexDirection:
                                        screenSize >= 768 ? 'unset' : 'column',
                                      borderBottom: '1px solid #DDDDDD',
                                      gap: screenSize >= 768 ? '32px' : 15,
                                      padding: '24px 0px',
                                      whiteSpace: 'pre-wrap',
                                      wordWrap: 'break-word',
                                    }}
                                  >
                                    <div
                                      style={{
                                        ...styles.infoText,
                                        width: 100,
                                        fontWeight: 700,
                                      }}
                                    >
                                      {_subitem.title}
                                    </div>
                                    <div
                                      style={{
                                        ...styles.infoText,
                                        flex: 1,
                                        color: '#444444',
                                      }}
                                    >
                                      <pre
                                        style={{
                                          ...styles.pre,
                                          wordBreak: 'break-all',
                                        }}
                                      >
                                        {_subitem.value}
                                      </pre>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ))}
                          </div>
                        </div>
                        {/* Detail 끝 */}

                        {/* SECTION: Review */}
                        <div ref={(el) => (contentRef['review'] = el)}>
                          <div>
                            <Title
                              style={{
                                ...styles.title,
                                paddingBottom: screenSize >= 768 ? 32 : 20,
                                borderBottom: '2px solid var(--black-color)',
                              }}
                            >
                              리뷰 (
                              {reviews.reviews.length > 999
                                ? '+999'
                                : reviews.reviews.length}
                              )
                            </Title>

                            <div>
                              {reviews.photo.length ? (
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginTop: 32,
                                  }}
                                >
                                  <Text
                                    size={screenSize >= 768 ? 16 : 14}
                                    weight={700}
                                  >
                                    포토/동영상 리뷰
                                  </Text>
                                  <button
                                    style={{
                                      border: 'none',
                                      background: 'none',
                                      cursor: 'pointer',
                                      color: '#666666',
                                    }}
                                    onClick={showPhotoModal}
                                  >
                                    전체보기{' '}
                                    <img src={more_666} alt="more icon" />
                                  </button>
                                  {/* 전체보기 모달 */}
                                  <ModalLayout
                                    type={
                                      screenSize >= 768 ? 'modal' : 'drawer'
                                    }
                                    placement="bottom"
                                    height={screenSize >= 768 ? null : '80%'}
                                    style={{ padding: '0px 15px' }}
                                    title={
                                      reviewDetail
                                        ? '포토/동영상 리뷰'
                                        : '전체 포토/동영상 리뷰'
                                    }
                                    open={isPhotoModalOpen}
                                    onCancel={closePhotoModal}
                                    closable
                                  >
                                    {reviewDetail ? (
                                      <ReviewItemDetail
                                        selectedImage={selectedImage}
                                        onSelectImage={setSelectedImage}
                                        screenSize={screenSize}
                                        data={reviewDetail}
                                        isShowList={true}
                                        onReviewDetail={setReviewDetail}
                                      />
                                    ) : (
                                      // <Content
                                      //   maxWidth="100%"
                                      //   padding="30px 0px"
                                      // >
                                      //   <Flex vertical gap={5} align="center">
                                      //     <div
                                      //       style={{
                                      //         display: 'flex',
                                      //         gap: 16,
                                      //         width: '100%',
                                      //         flexDirection:
                                      //           screenSize > 768
                                      //             ? 'row'
                                      //             : 'column',
                                      //       }}
                                      //     >
                                      //       {/* 이미지 왼쪽 */}
                                      //       <div
                                      //         style={{
                                      //           width:
                                      //             screenSize > 768
                                      //               ? '40%'
                                      //               : '100%',
                                      //         }}
                                      //       >
                                      //         {selectedImage?.type ===
                                      //         'IMAGE' ? (
                                      //           <img
                                      //             src={`${selectedImage?.file_url}`}
                                      //             alt="선택된 이미지"
                                      //             style={{
                                      //               width: '100%',
                                      //               height:
                                      //                 screenSize > 768
                                      //                   ? '488px'
                                      //                   : '300px',
                                      //               objectFit: 'contain',
                                      //               borderRadius: 8,
                                      //             }}
                                      //           />
                                      //         ) : (
                                      //           <video
                                      //             src={`${selectedImage?.file_url}`}
                                      //             alt="선택된 영상"
                                      //             style={{
                                      //               width: '100%',
                                      //               height:
                                      //                 screenSize > 768
                                      //                   ? '488px'
                                      //                   : '300px',
                                      //               borderRadius: 8,
                                      //               objectFit: 'contain',
                                      //               background: '#000',
                                      //             }}
                                      //             autoPlay
                                      //             muted
                                      //             loop
                                      //             playsInline
                                      //             controls
                                      //           />
                                      //         )}
                                      //         <div
                                      //           style={{
                                      //             marginTop: 12,
                                      //             display: 'flex',
                                      //             gap: 8,
                                      //             overflowX: 'auto',
                                      //           }}
                                      //         >
                                      //           {reviewDetail?.review_img?.map(
                                      //             (_item, idx) =>
                                      //               _item.type === 'IMAGE' ? (
                                      //                 <img
                                      //                   key={`review_file-${_item.review_file_id}`}
                                      //                   src={`${_item.file_url}`}
                                      //                   alt={`리뷰 이미지 ${idx}`}
                                      //                   style={{
                                      //                     width: 60,
                                      //                     height: 60,
                                      //                     objectFit: 'cover',
                                      //                     border:
                                      //                       selectedImage?.review_file_id ===
                                      //                       _item?.review_file_id
                                      //                         ? '2px solid #000'
                                      //                         : '1px solid #ccc',
                                      //                     borderRadius: 4,
                                      //                     cursor: 'pointer',
                                      //                   }}
                                      //                   onClick={() =>
                                      //                     setSelectedImage(
                                      //                       _item
                                      //                     )
                                      //                   }
                                      //                 />
                                      //               ) : (
                                      //                 <video
                                      //                   key={`review_file-${_item.review_file_id}`}
                                      //                   src={`${_item?.file_url}`}
                                      //                   width={60}
                                      //                   height={60}
                                      //                   muted
                                      //                   style={{
                                      //                     borderRadius: 4,
                                      //                     objectFit: 'cover',
                                      //                     border:
                                      //                       selectedImage?.review_file_id ===
                                      //                       _item?.review_file_id
                                      //                         ? '2px solid #000'
                                      //                         : '1px solid #ccc',
                                      //                     cursor: 'pointer',
                                      //                   }}
                                      //                   onClick={() =>
                                      //                     setSelectedImage(
                                      //                       _item
                                      //                     )
                                      //                   }
                                      //                 />
                                      //               )
                                      //           )}
                                      //         </div>
                                      //       </div>

                                      //       {/* 텍스트 우측 */}
                                      //       <div
                                      //         style={{
                                      //           width:
                                      //             screenSize > 768
                                      //               ? '60%'
                                      //               : '100%',
                                      //         }}
                                      //       >
                                      //         <div>
                                      //           <ul
                                      //             style={{
                                      //               display: 'flex',
                                      //               gap: 16,
                                      //             }}
                                      //           >
                                      //             <li>
                                      //               <img
                                      //                 src={Star}
                                      //                 alt="점수"
                                      //                 style={{
                                      //                   width: 16,
                                      //                   verticalAlign: 'middle',
                                      //                 }}
                                      //               />{' '}
                                      //               {parseFloat(
                                      //                 reviewDetail?.review_score
                                      //               ).toFixed(1) ?? '0.0'}
                                      //             </li>
                                      //             {'|'}
                                      //             <li>
                                      //               {reviewDetail?.user_name
                                      //                 ? `${reviewDetail?.user_name[0]}**`
                                      //                 : '비회원'}
                                      //             </li>
                                      //             {'|'}
                                      //             <li>
                                      //               {dayjs
                                      //                 .unix(
                                      //                   reviewDetail?.created_at
                                      //                 )
                                      //                 .format(`YYYY.MM.DD`)}
                                      //             </li>
                                      //           </ul>
                                      //         </div>

                                      //         <div
                                      //           style={{
                                      //             marginTop: 12,
                                      //             // maxHeight: 84,
                                      //             // overflow: 'hidden',
                                      //           }}
                                      //         >
                                      //           <p ref={contentRef}>
                                      //             {reviewDetail?.review_content}
                                      //           </p>
                                      //         </div>
                                      //       </div>
                                      //     </div>
                                      //     <Button
                                      //       onClick={() =>
                                      //         setReviewDetail(null)
                                      //       }
                                      //     >
                                      //       목록보기
                                      //     </Button>
                                      //   </Flex>
                                      // </Content>
                                      <Content maxWidth="100%" padding="0px">
                                        <div
                                          style={{
                                            overflowY: 'auto',
                                            maxHeight: 5 * 130,
                                            display: 'flex',
                                            justifyContent: 'flex-start',
                                            width: '100%',
                                            flexWrap: 'wrap',
                                            gap: screenSize >= 768 ? 8 : 3,
                                          }}
                                        >
                                          {reviews?.reviews?.map((review) => {
                                            const reviewImages =
                                              review.review_img || [];
                                            if (reviewImages.length === 0)
                                              return null;

                                            const firstImage = reviewImages[0];

                                            return (
                                              <div
                                                style={{
                                                  position: 'relative',
                                                  width:
                                                    screenSize >= 768
                                                      ? 120
                                                      : 80,
                                                  height:
                                                    screenSize >= 768
                                                      ? 120
                                                      : 80,
                                                  cursor: 'pointer',
                                                  borderRadius: 4,
                                                }}
                                                onClick={() => {
                                                  setReviewDetail(review);
                                                  setSelectedImage(firstImage);
                                                }} // 리뷰 클릭 시 상세 보기 등 처리
                                              >
                                                {firstImage?.type ===
                                                'IMAGE' ? (
                                                  <img
                                                    key={`image-${firstImage?.review_id}`}
                                                    src={firstImage?.file_url}
                                                    alt="시작 이미지"
                                                    style={{
                                                      width: '100%',
                                                      height: '100%',
                                                      objectFit: 'cover',
                                                      cursor: 'pointer',
                                                      borderRadius: 8,
                                                    }}
                                                  />
                                                ) : (
                                                  <video
                                                    key={`video-${firstImage?.review_id}`}
                                                    src={firstImage?.file_url}
                                                    width={'100%'}
                                                    height={'100%'}
                                                    muted
                                                    style={{
                                                      objectFit: 'cover',
                                                      cursor: 'pointer',
                                                    }}
                                                  />
                                                )}
                                                <div
                                                  style={{
                                                    position: 'absolute',
                                                    bottom: 4,
                                                    right: 4,
                                                    background:
                                                      'rgba(0, 0, 0, 0.6)',
                                                    color: '#fff',
                                                    padding: '2px 6px',
                                                    borderRadius: 12,
                                                    fontSize: 12,
                                                  }}
                                                >
                                                  {reviewImages?.length}
                                                </div>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </Content>
                                    )}
                                  </ModalLayout>
                                </div>
                              ) : null}

                              <div
                                style={{
                                  padding: '16px 0px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '16px',
                                  flexWrap: 'nowrap',
                                  overflow: 'hidden',
                                }}
                              >
                                {Photos?.slice(0, PAGE_SIZE)?.map(
                                  (_item, _index) =>
                                    _item.type === 'IMAGE' ? (
                                      <div>
                                        <Thumbnail
                                          size={screenSize >= 768 ? 138 : 100}
                                          src={_item?.file_url}
                                          onClick={showPhotoModal}
                                        />
                                      </div>
                                    ) : (
                                      <div>
                                        <video
                                          src={_item?.file_url}
                                          width={screenSize >= 768 ? 138 : 100}
                                          height={screenSize >= 768 ? 138 : 100}
                                          muted
                                          style={{
                                            objectFit: 'cover',
                                            cursor: 'pointer',
                                          }}
                                          onClick={showPhotoModal}
                                        />
                                      </div>
                                    )
                                )}
                              </div>
                            </div>

                            <div>
                              {reviews.reviews.length ? (
                                reviews.reviews
                                  .slice(
                                    (currentReviewPage - 1) * PAGE_COUNT,
                                    currentReviewPage * PAGE_COUNT
                                  )
                                  .map((_item, _index) => (
                                    <ReviewItem
                                      key={`review_${_item.review_id}`}
                                      reviewId={_item.review_id}
                                      score={_item.review_score}
                                      name={_item.user_name}
                                      content={_item.review_content}
                                      option={`${_item.product_name} - ${_item.product_option}`}
                                      img={_item.review_img}
                                      style={{
                                        fontSize: screenSize >= 768 ? 16 : 14,
                                      }}
                                      isDetail={true}
                                      onReviewDetail={handleReviewDetail}
                                    />
                                  ))
                              ) : (
                                <div style={{ padding: '28px 0px' }}>
                                  <Empty
                                    description={'등록된 리뷰가 없습니다.'}
                                  />
                                </div>
                              )}
                            </div>

                            <div
                              style={{ marginTop: screenSize >= 768 ? 52 : 20 }}
                            >
                              <Pagination
                                total={reviews.reviews.length}
                                pageSize={PAGE_SIZE}
                                showPage={5}
                                buttonStyle={{
                                  fontSize: screenSize >= 768 ? 16 : 14,
                                  fontWeight: 700,
                                  color: '#999999',
                                  background: 'none',
                                  width: 28,
                                  height: 28,
                                }}
                                isButton={true}
                                activeStyle={{
                                  color: `var(--black-color) !important`,
                                  borderBottom: '2px solid #111111',
                                }}
                                hoverStyle={{
                                  color: `var(--black-color) !important`,
                                }}
                                navStyle={{
                                  border: '1px solid var(--black-color)',
                                }}
                                isLatestButton={true}
                                onChange={(page) => setCurrentReviewPage(page)}
                              />
                            </div>
                          </div>
                        </div>
                        {/* Review 끝 */}

                        {/* SECTION: 상품문의 */}
                        <div ref={(el) => (contentRef['inquiry'] = el)}>
                          <div
                            style={{
                              paddingBottom: screenSize >= 768 ? 32 : 20,
                              borderBottom: '2px solid var(--black-color)',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            <Title
                              style={{
                                ...styles.title,
                              }}
                            >
                              상품 문의
                            </Title>
                            <button
                              style={{
                                border: 'none',
                                background: 'none',
                                cursor: 'pointer',
                                color: '#666666',
                              }}
                              onClick={showInquiryModal}
                            >
                              문의하기 <img src={more_666} alt="more icon" />
                            </button>
                          </div>

                          <div>
                            {inquiries.length ? (
                              inquiries
                                .slice(
                                  (currentInquiryPage - 1) * PAGE_COUNT,
                                  currentInquiryPage * PAGE_COUNT
                                )
                                .map((_item, _index) => (
                                  <CollapseItem
                                    title={_item.title}
                                    content={_item.content}
                                    answer={_item.answer}
                                    userName={_item.userName}
                                    answerName={_item.answerName}
                                    update={Formatter.unixToDate(
                                      _item.update,
                                      'YYYY.MM.DD'
                                    )}
                                    create={Formatter.unixToDate(
                                      _item.create,
                                      'YYYY.MM.DD'
                                    )}
                                    status={_item.status}
                                    secret={_item.secret}
                                    showContent={_item.secret ? false : true}
                                  />
                                ))
                            ) : (
                              <div style={{ padding: '28px 0px' }}>
                                <Empty
                                  description={'등록된 문의사항이 없습니다.'}
                                />
                              </div>
                            )}
                          </div>

                          <div
                            style={{ marginTop: screenSize >= 768 ? 60 : 20 }}
                          >
                            <Pagination
                              total={inquiries.length}
                              pageSize={PAGE_SIZE}
                              showPage={5}
                              buttonStyle={{
                                fontSize: screenSize >= 768 ? 16 : 14,
                                fontWeight: 700,
                                color: '#999999',
                                background: 'none',
                                width: 28,
                                height: 28,
                              }}
                              isButton={true}
                              activeStyle={{
                                color: `var(--black-color) !important`,
                                borderBottom: '2px solid #111111',
                              }}
                              hoverStyle={{
                                color: `var(--black-color) !important`,
                              }}
                              navStyle={{
                                border: '1px solid var(--black-color)',
                              }}
                              isLatestButton={true}
                              onChange={(page) => setCurrentInquiryPage(page)}
                            />
                          </div>
                        </div>
                        {/* 상품문의 끝 */}

                        {/* SECTION: 함께 본 상품 */}
                        {/* <Content maxWidth={'100%'} padding={0}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            paddingBottom: 32,
                          }}
                        >
                          <Title
                            style={{
                              ...styles.title,
                            }}
                          >
                            함께 본 상품
                          </Title>

                          <ul
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '12px',
                            }}
                          >
                            <li>
                              <Button
                                ref={prevRef}
                                style={{ ...styles.swiperButton }}
                              >
                                <img
                                  src={arrow_left_999}
                                  alt="more icon"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => goToPage('')}
                                />
                              </Button>
                            </li>
                            <li>1 / 5</li>
                            <li>
                              <Button
                                ref={nextRef}
                                style={{
                                  ...styles.swiperButton,
                                }}
                              >
                                <img
                                  src={more_999}
                                  alt="more icon"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => goToPage('')}
                                />
                              </Button>
                            </li>
                          </ul>
                        </div>

                        <Slider
                          slidesPerView={'auto'}
                          spaceBetween={24}
                          items={new Array(15).fill(null)}
                          itemStyle={{ width: 158 }}
                          modules={['Navigation']}
                          render={(props, index) => (
                            <div
                              key={`product_${index}`}
                              style={{ cursor: 'pointer' }}
                            >
                              <ProductItem.Image
                                src={GroupProduct}
                                title="JMCOFFEE"
                                hovered={false}
                                style={{ width: 158, height: 196 }}
                              />
                              <ProductItem.Title
                                title="JMCOFFEE"
                                style={{
                                  fontSize: 12,
                                  fontWeight: 700,
                                }}
                              />
                              <ProductItem.Title
                                title="시그니처블렌드 617th 에비뉴 200g"
                                style={{
                                  fontSize: 14,
                                  fontWeight: 500,
                                  padding: '4px 0px',
                                  fontFamily: 'Pretendard',
                                }}
                                maxLine={2}
                              />
                              <ProductItem.Price
                                price={24000}
                                discount={50}
                                style={{ fontSize: 16 }}
                              />
                              {
                                <ProductItem.Tags
                                  tags={[
                                    { id: 1, label: '특가' },
                                    { id: 2, label: '무료배송' },
                                  ]}
                                  style={{ fontSize: 12 }}
                                />
                              }
                            </div>
                          )}
                          onInit={(swiper) => {
                            swiper.params.navigation.prevEl = prevRef.current;
                            swiper.params.navigation.nextEl = nextRef.current;
                            swiper.navigation.init();
                            swiper.navigation.update();
                          }}
                        />
                      </Content> */}
                        {/* 함께 본 상품 끝 */}
                      </Content>
                    </Content>
                  </Content>
                </Col>
                <Col x={1} xl={0}></Col>
                <Col x={0} xl={8} xxl={6}>
                  <Content
                    maxWidth={'100%'}
                    padding={0}
                    style={{
                      borderBottom: '1px solid #111111',
                      paddingTop: 54,
                      display: screenSize >= 1200 ? 'block' : 'none',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        fontSize: 16,
                        fontWeight: 400,
                        lineHeight: '28px',
                        color: 'var(--black-color)',
                      }}
                    >
                      {/* 브랜드명 */}
                      <p>
                        {product?.shop_information?.shop_information_name}{' '}
                        {product?.shop_information?.is_brand === 'Y' ? (
                          <span>
                            <img
                              src={more}
                              alt="more icon"
                              style={{ cursor: 'pointer' }}
                              onClick={() =>
                                navigate(
                                  `/brand/${encodeURIComponent(
                                    encrypt(
                                      product?.shop_information
                                        ?.shop_information_id
                                    )
                                  )}`
                                )
                              }
                            />
                          </span>
                        ) : null}
                      </p>
                      {/* 찜/공유 버튼 */}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '24px',
                        }}
                      >
                        <button
                          style={{ ...styles.shareButton }}
                          onClick={() =>
                            onSubmit(isWish ? 'remove' : 'wishlist')
                          }
                        >
                          {isWish ? (
                            <HeartFilled style={{ color: '#D33444' }} />
                          ) : (
                            <HeartOutlined />
                          )}
                        </button>
                        <button
                          style={{ ...styles.shareButton }}
                          onClick={() => onCopyUrl()}
                        >
                          <ShareAltOutlined />
                        </button>
                      </div>
                    </div>

                    <Text
                      size={32}
                      weight={700}
                      style={{ marginTop: 24, wordBreak: 'keep-all' }}
                      maxLine={3}
                    >
                      {product?.product_name}
                    </Text>

                    {/* SECTION: 상품 가격 */}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginTop: 20,
                      }}
                    >
                      {product?.discount_price ? (
                        <div>
                          <Text
                            size={18}
                            weight={400}
                            color={'#BBBBBB'}
                            style={{
                              textDecoration: 'line-through',
                              marginBottom: 4,
                              display: 'flex',
                            }}
                          >
                            {product?.type === 'RENTAL' ? (
                              <small style={{ ...styles.prefix }}>월</small>
                            ) : (
                              ''
                            )}
                            {stringToMoneyFormat(
                              product?.type === 'RENTAL'
                                ? product?.monthlyPrice
                                : product?.price
                            )}
                            <div style={{ ...styles.wonsize }}>원</div>
                          </Text>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              flexDirection:
                                product?.discount_type === 'W'
                                  ? 'row-reverse'
                                  : 'row',
                            }}
                          >
                            <Text
                              weight={700}
                              color={'var(--danger-color)'}
                              style={{
                                paddingRight: 12,
                                lineHeight:
                                  product?.discount_type === 'W'
                                    ? '210%'
                                    : '175%',
                                fontSize:
                                  product?.discount_type === 'W' ? 16 : 20,
                              }}
                            >
                              {product?.discount_type === 'W'
                                ? `(${stringToMoneyFormat(
                                    product?.discount_rate
                                  )}원 할인)`
                                : `${product?.apply_discount_rate}%`}
                            </Text>
                            <Text
                              size={28}
                              weight={700}
                              style={{ display: 'flex' }}
                            >
                              {product?.type === 'RENTAL' ? (
                                <small style={{ ...styles.prefix }}>월</small>
                              ) : (
                                ''
                              )}
                              {stringToMoneyFormat(
                                product?.type === 'RENTAL'
                                  ? product?.finalMonthlyPrice
                                  : product?.finalPrice
                              )}
                              <div style={{ ...styles.wonsize }}>원</div>
                            </Text>

                            <ProductItem.Policies
                              policies={product?.policies}
                            />
                          </div>
                        </div>
                      ) : (
                        <Text
                          size={28}
                          weight={700}
                          style={{ paddingRight: 12, display: 'flex' }}
                        >
                          {product?.type === 'RENTAL' ? (
                            <small style={{ ...styles.prefix }}>월</small>
                          ) : (
                            ''
                          )}
                          {stringToMoneyFormat(
                            product?.type === 'RENTAL'
                              ? product?.finalMonthlyPrice
                              : product?.finalPrice
                          )}
                          <div style={{ ...styles.wonsize }}>원</div>
                        </Text>
                      )}
                    </div>

                    {/* SECTION: 태그 */}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: 24,
                        marginBottom: 32,
                      }}
                    >
                      {product?.tag?.length ? (
                        <ProductItem.Tags
                          tags={product?.tag.map((tag) => ({
                            id: tag.tag_id,
                            label: tag.tag_name,
                          }))}
                          style={{ flexWrap: 'wrap' }}
                        />
                      ) : null}
                    </div>
                  </Content>

                  {/* SECTION: 배송 정보 */}
                  <Content
                    maxWidth={'100%'}
                    padding={'32px 0'}
                    style={{ borderBottom: '1px solid #EEEEEE' }}
                  >
                    <div>
                      {[
                        // {
                        //   title: '타임세일',
                        //   content: (
                        //     <p style={{ color: 'var(--danger-color)' }}>
                        //       남은 시간 12일 19:04:54 (12,000원 할인)
                        //     </p>
                        //   ),
                        // },
                        ...(downloadCoupon
                          ? [
                              {
                                title: '쿠폰',
                                content: (
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      gap: 10,
                                    }}
                                  >
                                    {downloadCoupon.map((coupon) => (
                                      <div
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <div style={{ flex: 1 }}>
                                          <Text>{coupon.coupon_name}</Text>
                                          <Text size={12} color={'#999999'}>
                                            {coupon.start_date
                                              ? Formatter.unixToDate(
                                                  coupon.start_date,
                                                  'YYYY.MM.DD'
                                                )
                                              : ''}

                                            {coupon.start_date ||
                                            coupon.end_date
                                              ? ' ~ '
                                              : ''}

                                            {coupon.end_date
                                              ? Formatter.unixToDate(
                                                  coupon.end_date,
                                                  'YYYY.MM.DD'
                                                )
                                              : ''}
                                          </Text>
                                        </div>
                                        <button
                                          style={{
                                            cursor:
                                              coupon.isDownload === 'Y'
                                                ? 'default'
                                                : 'pointer',
                                            background: 'none',
                                            border: 'none',
                                          }}
                                          disabled={
                                            coupon.isDownload === 'Y'
                                              ? true
                                              : false
                                          }
                                          onClick={() =>
                                            onCouponDownload(coupon.coupon_code)
                                          }
                                        >
                                          {coupon.isDownload === 'Y' ? (
                                            <Text size={12} color={'#DDDDDD'}>
                                              발급완료
                                            </Text>
                                          ) : (
                                            <img
                                              src={Download}
                                              alt="다운로드"
                                            />
                                          )}
                                        </button>
                                      </div>
                                    ))}
                                  </div>
                                ),
                                wrapStyle: { alignItems: 'stretch' },
                                contentStyle: { flex: 1 },
                              },
                            ]
                          : []),
                        {
                          title: '택배사',
                          content: product?.forwarding_location
                            ? `${
                                DELIVERY_METHOD[
                                  product?.forwarding_location?.delivery_method
                                ]
                              } (${
                                CONSTANTS.DELIVERY_COMPANY[
                                  product?.forwarding_location?.delivery_company
                                ]?.label
                              })`
                            : '-',
                        },
                        {
                          title: '배송정보',
                          content: product?.forwarding_date
                            ? `${product?.forwarding_date}일 이내 출고`
                            : '당일 출고',
                        },
                        {
                          title: '배송비',
                          content: `${stringToMoneyFormat(
                            product?.forwarding_location?.delivery_price
                          )}원${
                            product?.forwarding_location?.free_delivery_price
                              ? ` (${stringToMoneyFormat(
                                  product?.forwarding_location
                                    ?.free_delivery_price
                                )}원 이상 무료배송)`
                              : ''
                          }`,
                        },
                        {
                          title: '포장타입',
                          content: `${
                            PACKAGE_METHOD[product?.packaging_method]
                          }`,
                        },
                        ...(product?.reserve_rate
                          ? [
                              {
                                title: '적립',
                                content: `+ ${stringToMoneyFormat(
                                  calculateDiscount(
                                    product?.finalPrice,
                                    product?.policy
                                  ).reserve,
                                  'P'
                                )}`,
                              },
                            ]
                          : []),
                        ...(product?.payment_additional_information
                          ? Object.entries(
                              product?.payment_additional_information
                            )?.map(([key, value]) => ({
                              title: key,
                              content: value,
                            }))
                          : []),
                      ].map((_item, _index) => (
                        <div
                          key={`payment_info_${_index}`}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: 16,
                            fontWeight: 400,
                            lineHeight: '24px',
                            color: 'var(--black-color)',
                            marginBottom: 16,
                            ..._item.wrapStyle,
                          }}
                        >
                          <div
                            style={{
                              width: 100,
                              fontWeight: 'unset',
                              color: '#777',
                              ...styles.titleStyle,
                            }}
                          >
                            {_item.title}
                          </div>
                          <div style={{ ...styles.contentStyle }}>
                            {_item.content}
                          </div>
                        </div>
                      ))}
                    </div>
                  </Content>

                  {/* SECTION 상품 옵션 */}
                  <div ref={stickyRef} style={{ height: 1, marginTop: -1 }} />
                  <Content
                    maxWidth={'100%'}
                    padding={0}
                    style={{
                      position: 'sticky',
                      top: 148,
                    }}
                  >
                    <Content maxWidth={'100%'} padding={'28px 0px'}>
                      <div>
                        <div style={{ ...styles.optionWrap }}>
                          {productOptions && isSticky ? (
                            <div>
                              <Text
                                size={14}
                                weight={700}
                                style={{
                                  wordBreak: 'keep-all',
                                }}
                              >
                                {product?.product_name}
                              </Text>
                            </div>
                          ) : null}
                          {productOptions && productOptions.REQUIRED.length ? (
                            <React.Fragment>
                              <p style={{ ...styles.optionTitle }}>필수옵션</p>
                              <div style={{ ...styles.optionContainer }}>
                                {productOptions.REQUIRED.map(
                                  (option, index) => {
                                    const findSelect = selectedOption.find(
                                      (select) =>
                                        select.option_id.toString() ===
                                        option.key
                                    );

                                    return (
                                      <Select
                                        key={`REQUIRED_${index}`}
                                        placeholder={`${option.title}`}
                                        options={option.children}
                                        style={{ ...styles.option }}
                                        size="large"
                                        onChange={(e) =>
                                          onOptionSelect('REQUIRED', e)
                                        }
                                        value={
                                          findSelect
                                            ? `${findSelect.option_id}-${findSelect.option.option_key}`
                                            : null
                                        }
                                        disabled={
                                          index === 0 ||
                                          (index !== 0 &&
                                            selectedOption[index - 1])
                                            ? false
                                            : true
                                        }
                                      />
                                    );
                                  }
                                )}
                              </div>
                            </React.Fragment>
                          ) : null}

                          {productOptions && productOptions.ADDITION.length ? (
                            <React.Fragment>
                              <p
                                style={{ ...styles.optionTitle, marginTop: 8 }}
                              >
                                추가옵션
                              </p>
                              <div style={{ ...styles.optionContainer }}>
                                {productOptions.ADDITION.map(
                                  (option, index) => {
                                    const findSelect = selectedOption.find(
                                      (select) =>
                                        select.option_id.toString() ===
                                        option.key
                                    );

                                    return (
                                      <Select
                                        key={`ADDITION_${index}`}
                                        placeholder={`${option.title}`}
                                        options={option.children}
                                        style={{ ...styles.option }}
                                        size="large"
                                        onChange={(e) =>
                                          onOptionSelect('ADDITION', e)
                                        }
                                        value={
                                          findSelect
                                            ? `${findSelect.option_id}-${findSelect.option.option_key}`
                                            : null
                                        }
                                      />
                                    );
                                  }
                                )}
                              </div>
                            </React.Fragment>
                          ) : null}

                          {product?.type === 'SUBSCRIPTION' ? (
                            <React.Fragment>
                              <Flex vertical gap={4}>
                                <div>
                                  <p style={{ ...styles.optionTitle }}>
                                    배송주기
                                  </p>
                                  <div style={{ ...styles.optionContainer }}>
                                    <Select
                                      placeholder={`배송주기를 선택해주세요`}
                                      options={
                                        product?.regular_information
                                          ?.regular_cycle
                                      }
                                      style={{ ...styles.option }}
                                      size="large"
                                      value={regularCycle?.regular_cycle}
                                      onChange={(e) =>
                                        setRegularCycle((prev) => ({
                                          ...prev,
                                          regular_cycle: e,
                                        }))
                                      }
                                    />
                                  </div>
                                </div>

                                <div>
                                  <p style={{ ...styles.optionTitle }}>
                                    배송횟수
                                  </p>
                                  <div style={{ ...styles.optionContainer }}>
                                    <Select
                                      placeholder={`배송횟수를 선택해주세요`}
                                      options={product?.regular_information?.max_regular_delivery_count
                                        ?.split(':')
                                        ?.map((item) => ({
                                          label:
                                            Number(item) === 0
                                              ? '제한없음'
                                              : `${item}회`,
                                          value: Number(item),
                                        }))}
                                      style={{ ...styles.option }}
                                      size="large"
                                      value={
                                        regularCycle?.max_regular_delivery_count
                                      }
                                      onChange={(e) =>
                                        setRegularCycle((prev) => ({
                                          ...prev,
                                          max_regular_delivery_count: e,
                                        }))
                                      }
                                    />
                                  </div>
                                </div>
                              </Flex>
                            </React.Fragment>
                          ) : null}

                          {(productOptions && productOptions.REQUIRED.length) ||
                          product?.type === 'SUBSCRIPTION' ? (
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                              }}
                            >
                              {product?.type === 'RENTAL' &&
                              selectedProduct.length ? null : (
                                <Button
                                  style={{
                                    borderRadius: 0,
                                    marginTop: 8,
                                    width: 80,
                                  }}
                                  onClick={() =>
                                    onProductList('ADD', 0, {
                                      ...product,
                                      cartNum: 1,
                                      ...regularCycle,
                                    })
                                  }
                                >
                                  담기
                                </Button>
                              )}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div
                        style={{
                          borderBottom: '1px solid var(--black-color)',
                          padding: '28px 0px',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '20px',
                        }}
                      >
                        {selectedProduct.map((_item, _index) => {
                          const { product_option } = _item;

                          const optionName = !product_option
                            ? ''
                            : product_option.reduce((acc, cur, index) => {
                                const optionName = cur.option[0].option_name;
                                return (acc += `${
                                  index ? ' / ' : ''
                                }${optionName}`);
                              }, '');

                          return (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: '20px',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '6px',
                                  flex: 1,
                                }}
                              >
                                <div style={{ flex: 1 }}>
                                  <Text size={16} weight={400}>
                                    {_item.product_name}{' '}
                                    {_item?.type === 'SUBSCRIPTION'
                                      ? `(${
                                          REGULAR_OPTION.find(
                                            (option) =>
                                              option.value ===
                                              _item.regular_cycle
                                          ).label
                                        }, ${
                                          _item?.max_regular_delivery_count ===
                                          0
                                            ? '제한없음'
                                            : `${_item?.max_regular_delivery_count}회`
                                        })`
                                      : null}
                                  </Text>
                                  <Text size={12} color={'#999999'}>
                                    {optionName}
                                  </Text>
                                </div>

                                {product_option?.length ||
                                _item.regular_cycle ? (
                                  <button
                                    style={{
                                      width: 18,
                                      height: 18,
                                      border: 'none',
                                      cursor: 'pointer',
                                      background: '#EEEEEE',
                                      borderRadius: '50%',
                                    }}
                                    onClick={() =>
                                      onProductList('REMOVE', _index)
                                    }
                                  >
                                    <img src={IconX} alt="remove" />
                                  </button>
                                ) : null}
                              </div>

                              {product.type === 'RENTAL' ? null : (
                                <Modifier
                                  init={_item.cartNum}
                                  minNum={1}
                                  maxNum={99}
                                  unit={null}
                                  layoutStyle={{
                                    width: 122,
                                    height: 36,
                                    background: 'none',
                                    border: 'none',
                                  }}
                                  buttonStyle={{
                                    border: 'none',
                                  }}
                                  onDecrease={() =>
                                    onProductList(
                                      'UPDATE',
                                      _index,
                                      --_item.cartNum
                                    )
                                  }
                                  onIncrease={() =>
                                    onProductList(
                                      'UPDATE',
                                      _index,
                                      ++_item.cartNum
                                    )
                                  }
                                  readOnly
                                />
                              )}
                            </div>
                          );
                        })}
                      </div>

                      {product?.type === 'RENTAL' ? null : (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            marginTop: 28,
                            gap: '12px',
                          }}
                        >
                          <Text size={16}>총 상품 금액</Text>
                          <Text
                            size={32}
                            weight={700}
                            color={'var(--danger-color)'}
                          >
                            {stringToMoneyFormat(totalPrice)}
                          </Text>
                        </div>
                      )}
                    </Content>

                    <Content maxWidth={'100%'} padding={0}>
                      {product?.type !== 'RENTAL' ? (
                        product?.is_amount === 'Y' ? (
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              gap: '8px',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                gap: '8px',
                              }}
                            >
                              <Button
                                type="secondary"
                                style={{
                                  ...styles.button,
                                  width: '100%',
                                  height: '100%',
                                }}
                                onClick={() => {
                                  if (product?.isSoldOut === 'Y') {
                                    MessageAlert.info('품절상품입니다.');
                                    return;
                                  }
                                  onSubmit('present', product.product_id);
                                }}
                              >
                                <img src={Gift} alt="선물하기" />
                                선물하기
                              </Button>
                            </div>
                          </div>
                        ) : (
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              gap: '8px',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                gap: '8px',
                              }}
                            >
                              {product?.is_present === 'Y' ? (
                                <Button
                                  type="secondary"
                                  style={{
                                    ...styles.button,
                                    width: 64,
                                    height: 64,
                                  }}
                                  onClick={() => {
                                    if (product?.isSoldOut === 'Y') {
                                      MessageAlert.info('품절상품입니다.');
                                      return;
                                    }
                                    onSubmit('present', product.product_id);
                                  }}
                                >
                                  <img src={Gift} alt="선물하기" />
                                </Button>
                              ) : null}

                              <Button
                                type="secondary"
                                style={{
                                  ...styles.button,
                                  height: 64,
                                  flex: 1,
                                }}
                                onClick={async () => {
                                  await onSubmit('cart').then((res) => {
                                    if (!res) return;

                                    const confirm = window.confirm(
                                      '장바구니에 추가되었습니다. 장바구니로 이동하시겠습니까?'
                                    );

                                    if (confirm) {
                                      navigate(
                                        `/order/cart?type=${product.type.toLocaleLowerCase()}`
                                      );
                                    } else {
                                      return;
                                    }
                                  });
                                }}
                              >
                                장바구니
                              </Button>
                              {product?.is_store_pickup === 'Y' ? (
                                <Button
                                  type="secondary"
                                  style={{
                                    ...styles.button,
                                    height: 64,
                                    flex: 1,
                                  }}
                                  onClick={() => {
                                    if (!selectedProduct.length) {
                                      MessageAlert.warning(
                                        '구매하실 상품을 선택해주세요!'
                                      );
                                      return;
                                    }

                                    setIsOpened('PICKUP');
                                  }}
                                >
                                  매장픽업
                                </Button>
                              ) : product?.isSoldOut === 'Y' ? (
                                <Button
                                  style={{
                                    ...styles.button,
                                    height: 64,
                                    flex: 1,
                                    background:
                                      product?.is_restocking_notification ===
                                      'N'
                                        ? '#DDDDDD'
                                        : '#111111',
                                  }}
                                  disabled={
                                    product?.is_restocking_notification === 'N'
                                      ? true
                                      : false
                                  }
                                  onClick={() =>
                                    onSubmit(
                                      isRestock ? 'unsubscribe' : 'subscribe'
                                    )
                                  }
                                >
                                  {product?.is_restocking_notification === 'Y'
                                    ? isRestock
                                      ? '재입고알림 해지'
                                      : '재입고알림'
                                    : '품절'}
                                </Button>
                              ) : (
                                <Button
                                  style={{
                                    ...styles.button,
                                    height: 64,
                                    flex: 1,
                                    background: '#111111',
                                  }}
                                  disabled={false}
                                  onClick={async () => {
                                    await onSubmit('cart').then((res) => {
                                      if (!res) return;

                                      navigate(
                                        `/order/cart?type=${product.type.toLocaleLowerCase()}`
                                      );
                                    });
                                  }}
                                >
                                  바로구매
                                </Button>
                              )}
                            </div>

                            {product?.is_store_pickup === 'Y' ? (
                              <Button
                                style={{
                                  ...styles.button,
                                  width: '100%',
                                  height: 64,
                                }}
                                onClick={async () => {
                                  await onSubmit('cart').then((res) => {
                                    if (!res) return;

                                    navigate('/order/cart');
                                  });
                                }}
                              >
                                바로구매
                              </Button>
                            ) : null}
                          </div>
                        )
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '8px',
                          }}
                        >
                          <Button
                            style={{
                              ...styles.button,
                              width: '100%',
                              height: 64,
                            }}
                            onClick={() => {
                              if (!selectedProduct || !selectedProduct.length)
                                return MessageAlert.info(
                                  '상품 옵션을 선택해주세요.'
                                );

                              setIsOpened('RENTAL');
                            }}
                          >
                            렌탈 계약 조건 선택
                          </Button>
                        </div>
                      )}

                      {product?.is_amount === 'N' ? (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginTop: 28,
                            gap: '8px',
                          }}
                        >
                          <Button
                            type="secondary"
                            style={{
                              ...styles.button,
                              width: '100%',
                              height: screenSize >= 1526 ? 64 : 'auto',
                              paddingLeft: 0,
                              background: 'var(--naver-color)',
                              borderColor: 'var(--naver-color)',
                              wordBreak: 'keep-all',
                            }}
                            onClick={() => onSubmit('naver_pay')}
                          >
                            <img src={Naver} alt="Naver Pay" />
                            네이버 pay 구매
                          </Button>
                          <Button
                            type="secondary"
                            style={{
                              ...styles.button,
                              width: '100%',
                              height: screenSize >= 1526 ? 64 : 'auto',
                              paddingLeft: 0,
                              background: 'var(--kakao-color)',
                              borderColor: 'var(--kakao-color)',
                              wordBreak: 'keep-all',
                            }}
                            onClick={() => onSubmit('kakao_pay')}
                          >
                            <img src={Kakao} alt="Kakao Pay" />
                            카카오 pay 구매
                          </Button>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </Content>
                  </Content>
                </Col>
                <Col x={0} xl={2} xxl={4}></Col>
              </Row>
              {/* 상품 정보 끝 */}
            </Col>
          </Row>
        </Content>

        {/* 모바일 fixed 장바구니, 바로구매 */}
        <div
          style={{
            position: 'fixed',
            display: screenSize >= 1200 ? 'none' : 'block',
            //bottom: screenSize >= 768 ? 0 : 64,
            bottom: screenSize >= 768 ? 0 : 80,
            left: 0,
            width: '100%',
            padding: screenSize >= 768 ? '20px 15px' : '10px 15px 15px 15px',
            backgroundColor: 'var(--white-color)',
            zIndex: 99999,
            borderTop: '1px solid #ddd',
            borderRadius: '30px 30px 0 0',
          }}
        >
          <Button
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              backgroundColor: 'transparent',
              border: 'none',
              paddingBottom: screenSize >= 768 ? 20 : 10,
            }}
            onClick={() => setIsOpen(true)}
          >
            <div
              style={{
                backgroundColor: '#ddd',
                width: '10vw',
                minWidth: 30,
                height: 5,
                borderRadius: 10,
              }}
            ></div>
          </Button>
          {product?.type !== 'RENTAL' ? (
            product?.is_amount === 'Y' ? (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    gap: '8px',
                  }}
                >
                  <Button
                    type="secondary"
                    style={{
                      ...styles.button,
                      width: '100%',
                      height: screenSize >= 768 ? 64 : '100%',
                      fontSize: screenSize >= 768 ? 15 : 13,
                    }}
                    onClick={() => {
                      if (product?.isSoldOut === 'Y') {
                        MessageAlert.info('품절상품입니다.');
                        return;
                      }
                      onSubmit('present', product.product_id);
                    }}
                  >
                    <img src={Gift} alt="선물하기" />
                    선물하기
                  </Button>
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    gap: '8px',
                  }}
                >
                  {product?.is_present === 'Y' ? (
                    <Button
                      type="secondary"
                      style={{
                        ...styles.button,
                        width: 64,
                        height: screenSize >= 768 ? 64 : 40,
                        fontSize: screenSize >= 768 ? 15 : 13,
                      }}
                      onClick={() => {
                        if (product?.isSoldOut === 'Y') {
                          MessageAlert.info('품절상품입니다.');
                          return;
                        }
                        onSubmit('present', product.product_id);
                      }}
                    >
                      <img src={Gift} alt="선물하기" />
                    </Button>
                  ) : null}

                  <Button
                    type="secondary"
                    style={{
                      ...styles.button,
                      height: screenSize >= 768 ? 64 : 40,
                      fontSize: screenSize >= 768 ? 15 : 13,
                      flex: 1,
                    }}
                    onClick={async () => {
                      await onSubmit('cart').then((res) => {
                        if (!res) return;

                        const confirm = window.confirm(
                          '장바구니에 추가되었습니다. 장바구니로 이동하시겠습니까?'
                        );

                        if (confirm) {
                          navigate(
                            `/order/cart?type=${product.type.toLocaleLowerCase()}`
                          );
                        } else {
                          return;
                        }
                      });
                    }}
                  >
                    장바구니
                  </Button>
                  {product?.is_store_pickup === 'Y' ? (
                    <Button
                      type="secondary"
                      style={{
                        ...styles.button,
                        height: screenSize >= 768 ? 64 : 40,
                        fontSize: screenSize >= 768 ? 15 : 13,
                        flex: 1,
                      }}
                      onClick={() => {
                        if (!selectedProduct.length) {
                          MessageAlert.warning('구매하실 상품을 선택해주세요!');
                          return;
                        }

                        setIsOpened('PICKUP');
                      }}
                    >
                      매장픽업
                    </Button>
                  ) : product?.isSoldOut === 'Y' ? (
                    <Button
                      style={{
                        ...styles.button,
                        height: screenSize >= 768 ? 64 : 40,
                        fontSize: screenSize >= 768 ? 15 : 13,
                        flex: 1,
                        background:
                          product?.is_restocking_notification === 'N'
                            ? '#DDDDDD'
                            : '#111111',
                      }}
                      disabled={
                        product?.is_restocking_notification === 'N'
                          ? true
                          : false
                      }
                      onClick={() =>
                        onSubmit(isRestock ? 'unsubscribe' : 'subscribe')
                      }
                    >
                      {product?.is_restocking_notification === 'Y'
                        ? isRestock
                          ? '재입고알림 해지'
                          : '재입고알림'
                        : '품절'}
                    </Button>
                  ) : (
                    <Button
                      style={{
                        ...styles.button,
                        height: screenSize >= 768 ? 64 : 40,
                        fontSize: screenSize >= 768 ? 15 : 13,
                        flex: 1,
                        background: '#111111',
                      }}
                      disabled={false}
                      onClick={async () => {
                        await onSubmit('cart').then((res) => {
                          if (!res) return;

                          navigate(
                            `/order/cart?type=${product.type.toLocaleLowerCase()}`
                          );
                        });
                      }}
                    >
                      바로구매
                    </Button>
                  )}
                </div>

                {product?.is_store_pickup === 'Y' ? (
                  <Button
                    style={{
                      ...styles.button,
                      width: '100%',
                      height: screenSize >= 768 ? 64 : 40,
                      fontSize: screenSize >= 768 ? 15 : 13,
                    }}
                    onClick={async () => {
                      await onSubmit('cart').then((res) => {
                        if (!res) return;

                        navigate('/order/cart');
                      });
                    }}
                  >
                    바로구매
                  </Button>
                ) : null}
              </div>
            )
          ) : (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <Button
                style={{
                  ...styles.button,
                  width: '100%',
                  height: screenSize >= 768 ? 64 : 40,
                  fontSize: screenSize >= 768 ? 15 : 13,
                }}
                onClick={() => {
                  if (!selectedProduct || !selectedProduct.length)
                    return MessageAlert.info('상품 옵션을 선택해주세요.');

                  setIsOpened('RENTAL');
                }}
              >
                렌탈 계약 조건 선택
              </Button>
            </div>
          )}
        </div>
      </div>

      {/* 스토어 픽업 매장 찾기 모달 */}
      <ModalLayout
        type="modal"
        centered
        title={'매장찾기'}
        open={isOpened === 'PICKUP'}
        onCancel={() => setIsOpened(null)}
        width={screenSize > 768 ? '30%' : '100%'}
        closable
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              gap: 12,
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <Btn onClick={() => setIsOpened(null)}>닫기</Btn>
            <Btn
              style={{ background: '#111111', color: '#FFFFFF' }}
              onClick={async () => {
                await onSubmit(
                  'cart',
                  selectPickupStore.forwarding_location_id
                ).then((res) => {
                  if (!res) return;

                  const confirm = window.confirm(
                    '장바구니에 추가되었습니다. 장바구니로 이동하시겠습니까?'
                  );

                  if (confirm) {
                    navigate(`/order/cart?type=store_pickup`);
                  } else {
                    return;
                  }
                });
              }}
            >
              픽업
            </Btn>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'24px 0px'}>
          <Row>
            <Col x={24}>
              <div style={{ width: '100%', height: 340 }}>
                <KakaoMap
                  address={selectPickupStore?.forwarding_address}
                  width={'100%'}
                  height={340}
                  name={selectPickupStore?.forwarding_name}
                />
                {/* <Img
                  src={`${STORE_URL}/${selectPickupStore?.receive_information?.pickup_location_map}`}
                  alt={`${selectPickupStore?.forwarding_name} 약도`}
                  width={'100%'}
                  height={'100%'}
                  style={{
                    objectFit: 'contain',
                  }}
                /> */}
              </div>

              <ul
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 12,
                  marginTop: 24,
                  borderTop: '2px solid #111111',
                  maxHeight: 300,
                  overflowY: 'scroll',
                }}
              >
                {product?.pickup?.map((pickup) => {
                  const isChecked =
                    selectPickupStore?.forwarding_location_id ===
                    pickup?.forwarding_location_id;

                  return (
                    <li
                      key={`pickup-${pickup?.forwarding_location_id}`}
                      style={{
                        cursor: 'pointer',
                        borderBottom: '1px solid #EEEEEE',
                        padding: '12px 0px',
                      }}
                      onClick={() => setSelectPickupStore(pickup)}
                    >
                      <div style={{ display: 'flex', gap: 12 }}>
                        <div>
                          <img
                            src={isChecked ? radio_checked : radio_unchecked}
                            alt={
                              isChecked
                                ? 'Checked radio icon'
                                : 'Unchecked radio icon'
                            }
                          />
                        </div>
                        <div /* style={{ flex: 1 }} */>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              //alignItems: 'center',
                              flexDirection:
                                screenSize >= 768 ? 'unset' : 'column',
                            }}
                          >
                            <div /* style={{ flex: 1 }} */>
                              <Text weight={700}>
                                {pickup?.forwarding_name}
                              </Text>
                              <div>
                                <Text
                                  size={14}
                                  color={'var(--light-gray-color)'}
                                >
                                  {pickup?.forwarding_address}
                                </Text>
                                <Text
                                  size={14}
                                  color={'var(--light-gray-color)'}
                                >
                                  {pickup?.forwarding_address_detail}
                                </Text>
                              </div>
                            </div>
                            <div>
                              {/* 연락처 */}
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 8,
                                }}
                              >
                                <Text size={14} weight={700}>
                                  대표 연락처.
                                </Text>
                                <Text
                                  size={14}
                                  color={'var(--dark-gray-color)'}
                                >
                                  {pickup?.phone}
                                </Text>
                              </div>
                              {/* 영업시간 */}
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 8,
                                }}
                              >
                                <Text size={14} weight={700}>
                                  영업시간.
                                </Text>
                                <Text
                                  size={14}
                                  color={'var(--dark-gray-color)'}
                                >
                                  {pickup?.receive_information?.business_hour}
                                </Text>
                              </div>
                              {/* 담당자 */}
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 8,
                                }}
                              >
                                <Text size={14} weight={700}>
                                  담당자.
                                </Text>
                                <Text
                                  size={14}
                                  color={'var(--dark-gray-color)'}
                                >
                                  {pickup?.receive_information?.manager_name}
                                </Text>
                              </div>
                            </div>
                          </div>

                          <div style={{ marginTop: 4 }}>
                            {/* 수령 가능일 */}
                            {pickup?.receive_information
                              ?.pickup_available_date ? (
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'flex-start',
                                  gap: 12,
                                }}
                              >
                                <Text weight={700} size={12}>
                                  수령가능일
                                </Text>
                                {pickup?.receive_information
                                  ?.pickup_available_date === 0 ? (
                                  <Text size={12}>당일수령가능</Text>
                                ) : (
                                  <Text size={12}>
                                    {`주문 완료 시점부터 ${pickup?.receive_information?.pickup_available_date}일 부터 수령 가능일자가 표시됩니다.`}
                                  </Text>
                                )}
                              </div>
                            ) : null}

                            {/* 수령지 안내 */}
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: 12,
                              }}
                            >
                              <Text weight={700} size={12}>
                                수령지안내
                              </Text>
                              <Text size={12}>
                                {
                                  pickup?.receive_information
                                    ?.pickup_instruction
                                }
                              </Text>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </Col>
          </Row>
        </Content>
      </ModalLayout>

      {/* 렌탈 계약 조건 모달 */}
      <ModalLayout
        type="modal"
        centered
        title={'렌탈신청'}
        open={isOpened === 'RENTAL'}
        onCancel={() => setIsOpened(null)}
        width={screenSize >= 768 ? 500 : '100%'}
        closable
        styles={{
          header: {
            padding: '20px 24px',
            marginBottom: 0,
          },
          content: {
            padding: 0,
          },
          footer: {
            marginTop: 0,
            padding: '20px 24px',
            boxShadow: '0 -10px 15px 0 rgba(0, 0, 0, 0.06)',
          },
        }}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              gap: 12,
              flexDirection: 'column',
            }}
          >
            {selectedRentalOption?.additional_cost ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: -12,
                }}
              >
                <Text size={12}>추가비용</Text>
                <Text size={14} weight={700}>
                  {stringToMoneyFormat(
                    selectedRentalOption?.additional_cost?.option_price,
                    '원'
                  )}
                </Text>
              </div>
            ) : null}

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <Text weight={700}>
                  <span
                    style={{ fontWeight: 400, fontSize: 14, paddingRight: 4 }}
                  >
                    계약
                  </span>
                  {selectedRentalOption?.contract_date?.option_value}
                  <span style={{ fontWeight: 500 }}>개월</span>
                </Text>
                <Text size={14}>|</Text>
                <Text weight={700}>
                  <span
                    style={{ fontWeight: 400, fontSize: 14, paddingRight: 4 }}
                  >
                    의무사용
                  </span>
                  {
                    selectedRentalOption?.contract_date?.mandatory_usage_date
                      ?.option_value
                  }
                  <span style={{ fontWeight: 500 }}>개월</span>
                </Text>
              </div>

              <Text size={24} weight={700} color={'#D33444'}>
                <span
                  style={{ fontWeight: 400, fontSize: 18, paddingRight: 4 }}
                >
                  월
                </span>
                {stringToMoneyFormat(rentalPrice)}
                <span style={{ fontWeight: 500 }}>원</span>
              </Text>
            </div>
            <div
              style={{
                height: 64,
                background: '#111111',
                width: '100%',
              }}
            >
              <Button
                style={{
                  ...styles.button,
                  height: '100%',
                  width: '100%',
                  background: '#111111',
                }}
                onClick={() => onSubmit('rental')}
              >
                렌탈 신청하기
              </Button>
            </div>
          </Content>
        }
      >
        <Content
          maxWidth={'100%'}
          padding={0}
          backgroundColor="#F5F5F5"
          maxHeight={'calc(100vh / 2)'}
          style={{ overflowY: 'scroll' }}
        >
          <Row>
            <Col x={24}>
              <Content
                maxWidth={'100%'}
                padding={24}
                backgroundColor="none"
                style={{ display: 'flex', flexDirection: 'column', gap: 24 }}
              >
                {/* 계약기간 */}
                <div>
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 4 }}
                  >
                    <Text weight={700}>계약기간</Text>
                    <Tooltip
                      title={
                        <pre style={{ ...styles.pre }}>
                          {
                            product?.rental_information
                              ?.contract_date_description
                          }
                        </pre>
                      }
                    >
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </div>

                  <div>
                    <RadioGroup
                      items={product?.rental_information?.contract_date?.map(
                        (item) => ({
                          ...item,
                          key: 'contract_date',
                        })
                      )}
                      name={`contract_date`}
                      value={selectedRentalOption?.contract_date?.option_key}
                      onChange={(e) => onSelectRentalOption(e)}
                    />
                  </div>
                </div>

                {/* 의무사용기간 */}
                <div>
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 4 }}
                  >
                    <Text weight={700}>의무 사용기간</Text>
                    <Tooltip
                      title={
                        <pre style={{ ...styles.pre }}>
                          {
                            product?.rental_information
                              ?.mandatory_usage_date_description
                          }
                        </pre>
                      }
                    >
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </div>

                  <div>
                    <RadioGroup
                      items={product?.rental_information?.contract_date
                        ?.find(
                          (item) =>
                            item.option_key ===
                            selectedRentalOption?.contract_date?.option_key
                        )
                        ?.mandatory_usage_date?.map((item) => ({
                          ...item,
                          key: 'mandatory_usage_date',
                        }))}
                      value={
                        selectedRentalOption?.contract_date
                          ?.mandatory_usage_date?.option_key
                      }
                      onChange={(e) => onSelectRentalOption(e)}
                    />
                  </div>
                </div>

                {/* 관리유형 */}
                <div>
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 4 }}
                  >
                    <Text weight={700}>관리유형</Text>
                    <Tooltip
                      title={
                        <pre style={{ ...styles.pre }}>
                          {product?.rental_information?.management_description}
                        </pre>
                      }
                    >
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </div>

                  <div>
                    <RadioGroup
                      items={product?.rental_information?.management?.map(
                        (item) => ({
                          ...item,
                          key: 'management',
                        })
                      )}
                      value={selectedRentalOption?.management?.option_key}
                      onChange={(e) => onSelectRentalOption(e)}
                    />
                  </div>
                </div>

                {/* 추가비용 */}
                <div>
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 4 }}
                  >
                    <Text weight={700}>추가비용</Text>
                    <Tooltip
                      title={
                        <pre style={{ ...styles.pre }}>
                          {
                            product?.rental_information
                              ?.additional_cost_description
                          }
                        </pre>
                      }
                    >
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </div>

                  <div>
                    <RadioGroup
                      items={product?.rental_information?.additional_cost?.map(
                        (item) => ({
                          ...item,
                          key: 'additional_cost',
                        })
                      )}
                      value={selectedRentalOption?.additional_cost?.option_key}
                      onChange={(e) => onSelectRentalOption(e)}
                      isCostShow
                    />
                  </div>
                </div>

                {/* 선납입금 */}
                <div>
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 4 }}
                  >
                    <Text weight={700}>선납입금</Text>
                    <Tooltip
                      title={
                        <pre style={{ ...styles.pre }}>
                          {
                            product?.rental_information
                              ?.advance_price_description
                          }
                        </pre>
                      }
                    >
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </div>

                  <div>
                    <RadioGroup
                      items={product?.rental_information?.advance_price?.map(
                        (item) => ({
                          ...item,
                          key: 'advance_price',
                        })
                      )}
                      value={selectedRentalOption?.advance_price?.option_key}
                      onChange={(e) => onSelectRentalOption(e)}
                    />
                  </div>
                </div>
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>

      {/* 상품문의 모달 */}
      <Modal
        title={
          <Title level={4} style={{ fontWeight: 700 }}>
            상품 문의
          </Title>
        }
        open={isInquiryModalOpen}
        onCancel={closeInquiryModal}
        footer={null}
        style={{
          minWidth: screenSize >= 768 ? '705px' : '100%',
          display: 'flex',
          height: screenSize >= 500 ? 'calc(100% - 87px)' : 'auto',
          alignItems: 'center',
          justifyContent: 'center',
          top: screenSize >= 768 ? 130 : screenSize >= 500 ? '40vh' : 110,
          bottom: screenSize >= 768 ? 'inherit' : 0,
          //paddingBottom: screenSize >= 768 ? 24 : 0,
          padding: 0,
          //margin: screenSize >= 768 ? 'inherit' : 0,
        }}
        closeIcon={<span style={{ fontSize: 18 }}>✖</span>}
      >
        <Spin spinning={isLoading}>
          <div style={{ paddingBottom: screenSize >= 768 ? 'inherit' : 60 }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  margin: '16px 0',
                }}
              >
                <Text>문의유형</Text>
                <span style={{ color: 'red', marginLeft: 4 }}>*</span>
              </div>
              <Select
                placeholder="문의 유형을 선택하세요.(필수)"
                style={{
                  width: '100%',
                  height: screenSize >= 768 ? 48 : 40,
                  marginBottom: 16,
                }}
                options={Object.entries(INQUIRY_SUB_TYPE).map(
                  ([key, value]) => ({
                    label: value,
                    value: key,
                  })
                )}
                value={inputValue.type ? inputValue.type : null}
                onChange={(e) => onChange('type', e)}
              />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 12,
                }}
              >
                <Text>문의내용</Text>
                <span style={{ color: 'red', marginLeft: 4 }}>*</span>
              </div>
              <Input
                placeholder="제목을 입력해주세요."
                style={{
                  border: '1px solid #DDDDDD',
                  height: screenSize >= 768 ? 48 : 40,
                  marginBottom: 16,
                }}
                value={inputValue.name}
                onChange={(e) => onChange('name', e.target.value)}
              />
              <TextArea
                rows={4}
                placeholder="문의 내용을 입력해주세요."
                style={{
                  border: '1px solid #DDDDDD',
                  height: 300,
                  marginBottom: 16,
                }}
                value={inputValue.content}
                onChange={(e) => onChange('content', e.target.value)}
              />
            </div>
            <div
              style={{
                display: 'flex',
                gap: 12,
                alignItems: 'center',
                marginBottom: 16,
              }}
              onClick={() => fileInputRef.current.click()}
            >
              <Button
                style={{
                  padding: '2px 8px',
                  borderRadius: 0,
                  fontSize: 14,
                  minWidth: 70,
                }}
              >
                사진첨부
              </Button>
              <input
                ref={fileInputRef}
                id="upload"
                type="file"
                multiple={true}
                accept={'image/*'}
                onChange={(e) => onFileList('add', e.target.files)}
              />
              <Text style={{ fontSize: 14, webkitLineClamp: 'unset' }}>
                최대 {maxFileCount}개 / 개당 {maxFileSize / 1024 / 1024}
                MB까지 첨부 가능합니다. (JPG, JPEG, PNG, GIF만 첨부 가능)
              </Text>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
              }}
            >
              {files.map((file, index) => {
                const link = URL.createObjectURL(file);

                return (
                  <div
                    key={`image-${index}`}
                    style={{
                      position: 'relative',
                      top: 0,
                      left: 0,
                    }}
                  >
                    <Image src={link} width={100} height={100} />

                    <button
                      style={{
                        position: 'absolute',
                        top: -10,
                        right: -10,
                        width: 20,
                        height: 20,
                        zIndex: 1,
                        cursor: 'pointer',
                        background: '#111111',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                      onClick={() => onFileList('remove', index)}
                    >
                      <img
                        src={plus_w}
                        alt="plus icon"
                        style={{
                          transform: 'rotate(45deg)',
                        }}
                      />
                    </button>
                  </div>
                );
              })}
            </div>
            {/* <Text style={{ marginBottom: 12 }}>
                                이메일 알림받기
                              </Text>
                              <Input
                                placeholder="예: jmcoffee@jm.co.kr"
                                style={{
                                  border: '1px solid #DDDDDD',
                                  height: 48,
                                  marginBottom: 16,
                                }}
                              /> */}

            {/* <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 9,
                                  }}
                                >
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 9,
                                    }}
                                  >
                                    <Checkbox
                                      checked={inputValue?.secret}
                                      onChange={(e) =>
                                        onChange('secret', e.target.checked)
                                      }
                                    />
                                    <Text>비밀글</Text>
                                  </label>
                                </div> */}

            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: screenSize >= 768 ? 24 : 10,
                marginTop: '5vh',
                paddingBottom: screenSize >= 768 ? 0 : '5vh',
              }}
            >
              <Button
                style={{
                  width: '22%',
                  minWidth: 90,
                  height: screenSize >= 768 ? 64 : 40,
                  fontSize: screenSize >= 768 ? 16 : 14,
                  fontWeight: 700,
                  borderRadius: '2px',
                  backgroundColor: 'white',
                  color: 'black',
                  border: '1px solid black',
                }}
                onClick={closeInquiryModal}
              >
                취소
              </Button>
              <Button
                style={{
                  width: '22%',
                  minWidth: 90,
                  height: screenSize >= 768 ? 64 : 40,
                  fontSize: screenSize >= 768 ? 16 : 14,
                  fontWeight: 700,
                  borderRadius: '2px',
                }}
                onClick={() => onReception(closeInquiryModal)}
              >
                문의하기
              </Button>
            </div>
          </div>
        </Spin>
      </Modal>
      {/* 상품문의 모달 끝 */}

      {/* 모바일 상품 fixed 상품 옵션 모달 */}
      <ModalLayout
        maxWidth={'100%'}
        type="drawer"
        open={isOpen}
        onChange={setIsOpen}
        placement="bottom"
        //height={'fit-content'}
        height={screenSize >= 500 ? '440px' : '330px'}
        onCancel={() => setIsOpen(false)}
        closable
      >
        {/* SECTION 상품 옵션 */}
        <Content maxWidth={'100%'} padding={0}>
          <Content
            maxWidth={'100%'}
            padding={screenSize >= 768 ? '0 0px 28px' : '0 0 20px'}
          >
            <div>
              <div style={{ ...styles.optionWrap }}>
                {productOptions && productOptions.REQUIRED.length ? (
                  <React.Fragment>
                    <p style={{ ...styles.optionTitle }}>필수옵션</p>
                    <div style={{ ...styles.optionContainer }}>
                      {productOptions.REQUIRED.map((option, index) => {
                        const findSelect = selectedOption.find(
                          (select) => select.option_id.toString() === option.key
                        );
                        return (
                          <Select
                            key={`REQUIRED_${index}`}
                            placeholder={`${option.title}`}
                            options={option.children}
                            style={{ ...styles.option }}
                            size="large"
                            onChange={(e) => onOptionSelect('REQUIRED', e)}
                            value={
                              findSelect
                                ? `${findSelect.option_id}-${findSelect.option.option_key}`
                                : null
                            }
                            disabled={
                              index === 0 ||
                              (index !== 0 && selectedOption[index - 1])
                                ? false
                                : true
                            }
                          />
                        );
                      })}
                    </div>
                  </React.Fragment>
                ) : null}
                {productOptions && productOptions.ADDITION.length ? (
                  <React.Fragment>
                    <p
                      style={{
                        ...styles.optionTitle,
                        marginTop: 8,
                      }}
                    >
                      추가옵션
                    </p>
                    <div style={{ ...styles.optionContainer }}>
                      {productOptions.ADDITION.map((option, index) => {
                        const findSelect = selectedOption.find(
                          (select) => select.option_id.toString() === option.key
                        );
                        return (
                          <Select
                            key={`ADDITION_${index}`}
                            placeholder={`${option.title}`}
                            options={option.children}
                            style={{ ...styles.option }}
                            size="large"
                            onChange={(e) => onOptionSelect('ADDITION', e)}
                            value={
                              findSelect
                                ? `${findSelect.option_id}-${findSelect.option.option_key}`
                                : null
                            }
                          />
                        );
                      })}
                    </div>
                  </React.Fragment>
                ) : null}
                {product?.type === 'SUBSCRIPTION' ? (
                  <React.Fragment>
                    <Flex vertical gap={4}>
                      <div>
                        <p style={{ ...styles.optionTitle }}>배송주기</p>
                        <div style={{ ...styles.optionContainer }}>
                          <Select
                            placeholder={`배송주기를 선택해주세요`}
                            options={
                              product?.regular_information?.regular_cycle
                            }
                            style={{ ...styles.option }}
                            size="large"
                            value={regularCycle?.regular_cycle}
                            onChange={(e) =>
                              setRegularCycle((prev) => ({
                                ...prev,
                                regular_cycle: e,
                              }))
                            }
                          />
                        </div>
                      </div>

                      <div>
                        <p style={{ ...styles.optionTitle }}>배송횟수</p>
                        <div style={{ ...styles.optionContainer }}>
                          <Select
                            placeholder={`배송횟수를 선택해주세요`}
                            options={product?.regular_information?.max_regular_delivery_count
                              ?.split(':')
                              ?.map((item) => ({
                                label:
                                  Number(item) === 0 ? '제한없음' : `${item}회`,
                                value: Number(item),
                              }))}
                            style={{ ...styles.option }}
                            size="large"
                            value={regularCycle?.max_regular_delivery_count}
                            onChange={(e) =>
                              setRegularCycle((prev) => ({
                                ...prev,
                                max_regular_delivery_count: e,
                              }))
                            }
                          />
                        </div>
                      </div>
                    </Flex>
                  </React.Fragment>
                ) : null}
                {(productOptions && productOptions.REQUIRED.length) ||
                product?.type === 'SUBSCRIPTION' ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    {product?.type === 'RENTAL' &&
                    selectedProduct.length ? null : (
                      <Button
                        style={{
                          borderRadius: 0,
                          marginTop: 8,
                          width: 80,
                          fontSize: screenSize >= 768 ? 16 : 14,
                        }}
                        onClick={() =>
                          onProductList('ADD', 0, {
                            ...product,
                            cartNum: 1,
                            ...regularCycle,
                          })
                        }
                      >
                        담기
                      </Button>
                    )}
                  </div>
                ) : null}
              </div>
            </div>
            <div
              style={{
                borderBottom: '1px solid var(--black-color)',
                paddingBottom: screenSize >= 768 ? 28 : 20,
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
              }}
            >
              {selectedProduct.map((_item, _index) => {
                const { product_option } = _item;
                const optionName = !product_option
                  ? ''
                  : product_option.reduce((acc, cur, index) => {
                      const optionName = cur.option[0].option_name;
                      return (acc += `${index ? ' / ' : ''}${optionName}`);
                    }, '');
                return (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: '20px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        flex: 1,
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <Text
                          size={screenSize >= 768 ? 16 : 14}
                          weight={400}
                          style={{
                            webkitLineClamp: 'unset',
                            textOverflow: 'unset',
                          }}
                        >
                          {_item.product_name}{' '}
                          {_item?.type === 'SUBSCRIPTION'
                            ? `(${
                                REGULAR_OPTION.find(
                                  (option) =>
                                    option.value === _item.regular_cycle
                                ).label
                              }, ${
                                _item?.max_regular_delivery_count === 0
                                  ? '제한없음'
                                  : `${_item?.max_regular_delivery_count}회`
                              })`
                            : null}
                        </Text>
                        <Text
                          size={12}
                          color={'#999999'}
                          style={{
                            webkitLineClamp: 'unset',
                            textOverflow: 'unset',
                          }}
                        >
                          {optionName}
                        </Text>
                      </div>
                      {product_option?.length || _item.regular_cycle ? (
                        <button
                          style={{
                            width: 18,
                            height: 18,
                            border: 'none',
                            cursor: 'pointer',
                            background: '#EEEEEE',
                            borderRadius: '50%',
                          }}
                          onClick={() => onProductList('REMOVE', _index)}
                        >
                          <img src={IconX} alt="remove" />
                        </button>
                      ) : null}
                    </div>
                    {product.type === 'RENTAL' ? null : (
                      <Modifier
                        init={_item.cartNum}
                        minNum={1}
                        maxNum={99}
                        unit={null}
                        layoutStyle={{
                          width: 122,
                          height: 36,
                          background: 'none',
                          border: 'none',
                        }}
                        buttonStyle={{
                          border: 'none',
                        }}
                        onDecrease={() =>
                          onProductList('UPDATE', _index, --_item.cartNum)
                        }
                        onIncrease={() =>
                          onProductList('UPDATE', _index, ++_item.cartNum)
                        }
                        readOnly
                      />
                    )}
                  </div>
                );
              })}
            </div>
            {product?.type === 'RENTAL' ? null : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  marginTop: screenSize >= 768 ? 28 : 20,
                  gap: '12px',
                }}
              >
                <Text size={screenSize >= 768 ? 16 : 14}>총 상품 금액</Text>
                <Text
                  size={screenSize >= 768 ? 32 : 20}
                  weight={700}
                  color={'var(--danger-color)'}
                >
                  {stringToMoneyFormat(totalPrice)}
                </Text>
              </div>
            )}
          </Content>
          <Content maxWidth={'100%'} padding={0}>
            {product?.type !== 'RENTAL' ? (
              product?.type === 'AMOUNT' ?? (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                      gap: '8px',
                    }}
                  >
                    {product?.is_present === 'Y' ? (
                      <Button
                        type="secondary"
                        style={{
                          ...styles.button,
                          width: 64,
                          height: screenSize >= 768 ? 64 : 40,
                        }}
                        onClick={() => {
                          if (product?.isSoldOut === 'Y') {
                            MessageAlert.info('품절상품입니다.');
                            return;
                          }
                          onSubmit('present', product.product_id);
                        }}
                      >
                        <img src={Gift} alt="선물하기" />
                      </Button>
                    ) : null}
                    <Button
                      type="secondary"
                      style={{
                        ...styles.button,
                        height: screenSize >= 768 ? 64 : 40,
                        flex: 1,
                      }}
                      onClick={async () => {
                        await onSubmit('cart').then((res) => {
                          if (!res) return;
                          const confirm = window.confirm(
                            '장바구니에 추가되었습니다. 장바구니로 이동하시겠습니까?'
                          );
                          if (confirm) {
                            navigate(
                              `/order/cart?type=${product.type.toLocaleLowerCase()}`
                            );
                          } else {
                            return;
                          }
                        });
                      }}
                    >
                      장바구니
                    </Button>
                    {product?.is_store_pickup === 'Y' ? (
                      <Button
                        type="secondary"
                        style={{
                          ...styles.button,
                          height: screenSize >= 768 ? 64 : 40,
                          flex: 1,
                        }}
                        onClick={() => {
                          if (!selectedProduct.length) {
                            MessageAlert.warning(
                              '구매하실 상품을 선택해주세요!'
                            );
                            return;
                          }
                          setIsOpened('PICKUP');
                        }}
                      >
                        매장픽업
                      </Button>
                    ) : product?.isSoldOut === 'Y' ? (
                      <Button
                        style={{
                          ...styles.button,
                          height: screenSize >= 768 ? 64 : 40,
                          flex: 1,
                          background:
                            product?.is_restocking_notification === 'N'
                              ? '#DDDDDD'
                              : '#111111',
                        }}
                        disabled={
                          product?.is_restocking_notification === 'N'
                            ? true
                            : false
                        }
                        onClick={() =>
                          onSubmit(isRestock ? 'unsubscribe' : 'subscribe')
                        }
                      >
                        {product?.is_restocking_notification === 'Y'
                          ? isRestock
                            ? '재입고알림 해지'
                            : '재입고알림'
                          : '품절'}
                      </Button>
                    ) : (
                      <Button
                        style={{
                          ...styles.button,
                          height: screenSize >= 768 ? 64 : 40,
                          flex: 1,
                          background: '#111111',
                        }}
                        disabled={false}
                        onClick={async () => {
                          await onSubmit('cart').then((res) => {
                            if (!res) return;
                            navigate(
                              `/order/cart?type=${product.type.toLocaleLowerCase()}`
                            );
                          });
                        }}
                      >
                        바로구매
                      </Button>
                    )}
                  </div>
                  {product?.is_store_pickup === 'Y' ? (
                    <Button
                      style={{
                        ...styles.button,
                        width: '100%',
                        height: screenSize >= 768 ? 64 : 40,
                      }}
                      onClick={async () => {
                        await onSubmit('cart').then((res) => {
                          if (!res) return;
                          navigate('/order/cart');
                        });
                      }}
                    >
                      바로구매
                    </Button>
                  ) : null}
                </div>
              )
            ) : (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <Button
                  style={{
                    ...styles.button,
                    width: '100%',
                    height: screenSize >= 768 ? 64 : 40,
                  }}
                  onClick={() => {
                    if (!selectedProduct || !selectedProduct.length)
                      return MessageAlert.info('상품 옵션을 선택해주세요.');
                    setIsOpened('RENTAL');
                  }}
                >
                  렌탈 계약 조건 선택
                </Button>
              </div>
            )}
            {product?.type === 'AMOUNT' ?? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: screenSize >= 500 ? 28 : 15,
                  gap: '8px',
                }}
              >
                <Button
                  type="secondary"
                  style={{
                    ...styles.button,
                    width: '100%',
                    height: screenSize >= 768 ? 64 : 40,
                    paddingLeft: 0,
                    fontSize: screenSize >= 500 ? 15 : 12,
                    background: 'var(--naver-color)',
                    borderColor: 'var(--naver-color)',
                  }}
                  onClick={() => onSubmit('naver_pay')}
                >
                  <img
                    src={Naver}
                    alt="Naver Pay"
                    width={screenSize >= 768 ? 'unset' : 30}
                  />
                  네이버 pay 구매
                </Button>
                <Button
                  type="secondary"
                  style={{
                    ...styles.button,
                    width: '100%',
                    height: screenSize >= 768 ? 64 : 40,
                    paddingLeft: 0,
                    fontSize: screenSize >= 500 ? 15 : 12,
                    background: 'var(--kakao-color)',
                    borderColor: 'var(--kakao-color)',
                  }}
                  onClick={() => onSubmit('kakao_pay')}
                >
                  <img
                    src={Kakao}
                    alt="Kakao Pay"
                    width={screenSize >= 768 ? 'unset' : 30}
                  />
                  카카오 pay 구매
                </Button>
              </div>
            )}
          </Content>
        </Content>
      </ModalLayout>
    </React.Fragment>
  );
};

export default ProductDetailPresenter;
